// ============================================================================
// CONFIGURATION
// ============================================================================

const CONFIG = {
    MAX_ALTERNATIVES: 3,
    TOTAL_DURATION_MS: 90000,
    CACHE_DURATION_MS: 30 * 60 * 1000,
    DRAWER_WIDTH: '420px',
    COLORS: { success: '#2FAE55', error: '#ef4444' },

    // Zeitbasierte Loading-Messages (in Millisekunden)
    LOADING_MESSAGES: [
        { minTime: 0,     text: "Gartenfoto wird hochgeladen..." },
        { minTime: 3000,  text: "Baumschulmeister checkt das Lager..." },
        { minTime: 8000,  text: "Gärtner studiert dein Foto mit der Lupe..." },
        { minTime: 15000, text: "Passende Pflanzen werden ausgewählt..." },
        { minTime: 25000, text: "Der Landschaftsarchitekt skizziert fleißig..." },
        { minTime: 40000, text: "Farbtöpfe werden gemischt..." },
        { minTime: 55000, text: "Blüten und Gräser werden platziert..." },
        { minTime: 70000, text: "Gartenplan wird poliert..." },
        { minTime: 85000, text: "Gleich geschafft..." },
        { minTime: 100000, text: "Noch einen Moment Geduld..." }
    ],

    STARTER_PROMPTS: [
        "Ich möchte einen bienenfreundlichen, pflegeleichten Garten mit bunten Sträuchern.",
        "Ich wünsche mir einen modernen, cleanen Look mit Gräsern und einheitlichen Farben.",
        "Ein rustikaler Landhaus-Garten mit vielen blühenden Rosen und bunten Blüten.",
        "Pflegeleichter Garten mit immergrünen Hecken für Sichtschutz und wenig Rasen.",
        "Ich möchte einen naturnahen Garten mit heimischen Pflanzen."
    ],

    // B: eigene Folge fuer den Neuentwurf. Die Liste oben beschreibt den
    // ersten Lauf (Foto hochladen, Lager pruefen, Pflanzen auswaehlen) -
    // davon passiert beim Neuentwurf nichts. Ranking und Bildanalyse laufen
    // nicht erneut, deshalb ist er auch deutlich kuerzer.
    NEUENTWURF_MESSAGES: [
        { minTime: 0,     text: "Deine Pflanzenliste wird übernommen..." },
        { minTime: 4000,  text: "Der Landschaftsarchitekt zeichnet um..." },
        { minTime: 12000, text: "Blüten und Gräser werden neu platziert..." },
        { minTime: 28000, text: "Gartenplan wird poliert..." },
        { minTime: 42000, text: "Gleich geschafft..." },
        { minTime: 55000, text: "Noch einen Moment Geduld..." }
    ],
    NEUENTWURF_DURATION_MS: 50000,

    // Beschriftung des Neuentwurf-Knopfes. Der Zaehler stand bis zum
    // 08.09.2026 als "noch 3 von 3" unter dem Knopf und verkaufte eine
    // Beschraenkung, die die meisten nie erreichen - die allermeisten machen
    // einen oder zwei Entwuerfe. Jetzt steht die Zahl nur da, wo sie etwas
    // erklaert: am gesperrten Knopf.
    NEUENTWURF_LABEL: 'Entwurf neu generieren',
    NEUENTWURF_LABEL_AUS: 'Entwurf neu generieren ({verbraucht} von {grenze} verwendet)',
    NEUENTWURF_HINWEIS: 'Ändere zuerst eine Stückzahl',
    // Sobald der Kunde selbst eine Pflanze aufgenommen hat, ist "neu
    // generieren" die falsche Zusage - der Entwurf wird nicht neu erfunden,
    // sondern um das ergaenzt, was er ausgesucht hat.
    NEUENTWURF_LABEL_MANUELL: 'Entwurf mit deinen Änderungen neu berechnen',

    // Katalogsuche in der Pflanzliste
    SUCHE_PLATZHALTER: 'Pflanze hinzufügen…',
    SUCHE_MIN_ZEICHEN: 2,
    SUCHE_MAX_TREFFER: 8,
    SUCHE_SCHWELLE: 0.35,
    FUSE_CDN: 'https://cdnjs.cloudflare.com/ajax/libs/fuse.js/7.0.0/fuse.min.js',
    // E-17: Subresource Integrity fuer das nachgeladene Fuse.js. Liegt hinter
    // der URL ein anderer Inhalt, laedt der Browser das Skript nicht, und die
    // Suche faellt auf den Teilstring-Vergleich zurueck (ladeFuse). Neuer
    // Hash bei Versionswechsel: openssl dgst -sha384 -binary fuse.min.js | openssl base64 -A
    FUSE_SRI: 'sha384-PCSoOZTpbkikBEtd/+uV3WNdc676i9KUf01KOA8CnJotvlx8rRrETbDuwdjqTYvt',
    // E-19: absolute Links nur zu diesen Hosts. Die Katalog-URLs kommen vom
    // Server, ein manipulierter Speicherstand koennte aber beliebige tragen.
    ERLAUBTE_LINK_HOSTS: ['baumfink.de', 'www.baumfink.de', 'cdn.shopify.com'],
    // Rueckfall im Katalog: erst wenn die Suche im Browser leer ausgeht, und
    // erst wenn der Kunde aufgehoert hat zu tippen. Der Aufruf kostet ein
    // Modell - bei jedem Tastendruck waere er Verschwendung.
    SUCHE_RUECKFALL_MS: 400,
    SUCHE_RUECKFALL_TEXT: 'Suche im Katalog…',

    CHIP_PRESETS: [
        'mehr Blüten','mehr Gräser','mehr Immergrün','weiße Akzente','ruhiger',
        'natürlicher','moderner','weniger Pflege','mehr Sichtschutz'
    ],

    // Retry-Konfiguration - angepasst für Job-Queue
    MAX_RETRIES: 2,
    REQUEST_TIMEOUT_MS: 120000,  // 120s für Upload großer Bilder über mobile Netze

    // Polling-Konfiguration für Job-Queue
    POLL_INTERVAL_MS: 3000,           // 3s zwischen Polls
    POLL_MAX_DURATION_MS: 300000,     // 5 Minuten maximale Polling-Dauer
    POLL_MAX_NETWORK_ERRORS: 10,      // Max 10 Netzwerkfehler in Folge
    POLL_BACKOFF_MULTIPLIER: 1.5      // Backoff bei Netzwerkfehlern
};

const STORAGE_KEYS = {
    session: 'gartenplaner_session',
    addedCart: 'gartenplaner_added_alternatives',
    // E-18: das Kundenfoto liegt NUR hier (sessionStorage: stirbt mit dem Tab),
    // nie im localStorage.
    foto: 'gartenplaner_foto'
};

// E-19: Versionskennung dieser Datei. Wird von tools/frontend_version.py aus
// dem Inhalt berechnet (Datum + Hash) und vor dem Theme-Upload gesetzt;
// tools/frontend_version.py --pruefen schlaegt an, wenn sie nicht mehr passt.
// Shopify versioniert die Asset-URL selbst; der frueher von Hand gepflegte
// Zusatz ?v=... in page.gartenplaner.liquid ist entfallen.
const GP_VERSION = '2026-09-10.5f9b7a932a';

// ============================================================================
// UTILITY FUNCTIONS
// ============================================================================

/**
 * Promise-based sleep function for async/await usage.
 * @param {number} ms - Milliseconds to wait
 */
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// ============================================================================
// SECURITY UTILITIES (XSS Prevention)
// ============================================================================

/**
 * Escapes HTML special characters to prevent XSS attacks.
 * Use for any user-provided or server-provided text content.
 */
function escapeHtml(text) {
    if (text === null || text === undefined) return '';
    const str = String(text);
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
}

/**
 * Sanitizes URLs to prevent javascript: and data: XSS attacks.
 * Only allows http:, https:, and relative URLs.
 */
function sanitizeUrl(url) {
    if (!url || typeof url !== 'string') return '';
    const trimmed = url.trim();
    // Allow relative URLs
    if (trimmed.startsWith('/') || trimmed.startsWith('./') || trimmed.startsWith('../')) {
        return trimmed;
    }
    // Allow only http and https protocols
    try {
        const parsed = new URL(trimmed);
        if ((parsed.protocol === 'http:' || parsed.protocol === 'https:')
            && CONFIG.ERLAUBTE_LINK_HOSTS.includes(parsed.hostname.toLowerCase())) {
            return trimmed;
        }
    } catch (e) {
        // Invalid URL
    }
    return '';
}

/**
 * Sanitizes HTML content by allowing only safe tags and attributes.
 * Used for AI-generated descriptions that may contain formatting.
 */
function sanitizeHtml(html) {
    if (!html || typeof html !== 'string') return '';

    // E-16: in ein INERTES Dokument parsen, nicht per innerHTML in ein
    // Element des lebenden Dokuments. Dort laedt der Browser <img src=x>
    // sofort und fuehrt onerror=... aus, BEVOR die Bereinigung darunter
    // das Attribut entfernt - der klassische Bypass innerHTML-basierter
    // Sanitizer. Im DOMParser-Dokument laufen keine Skripte, keine Loader,
    // keine Handler. (Gefunden bei der Abnahme am 09.09.2026: ein
    // <img src=x onerror=alert(1)> im Testfall blockierte den Browser.)
    const temp = new DOMParser().parseFromString(html, 'text/html').body;

    // Allowed tags whitelist
    const allowedTags = ['p', 'br', 'strong', 'em', 'b', 'i', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div'];

    // Recursively clean the DOM
    function cleanNode(node) {
        const childNodes = Array.from(node.childNodes);

        for (const child of childNodes) {
            if (child.nodeType === Node.ELEMENT_NODE) {
                const tagName = child.tagName.toLowerCase();

                // Remove disallowed tags but keep their text content
                if (!allowedTags.includes(tagName)) {
                    // For script/style tags, remove completely
                    if (['script', 'style', 'iframe', 'object', 'embed', 'template', 'noscript'].includes(tagName)) {
                        child.remove();
                        continue;
                    }
                    // For other disallowed tags, replace with text content
                    const textContent = child.textContent;
                    child.replaceWith(document.createTextNode(textContent));
                    continue;
                }

                // E-16: keine Attribute, keine Ausnahme. Bis 09.09.2026 stand
                // hier eine schwarze Liste (on*, href, src, ...), die style,
                // id, class und data-* durchliess. Ein ueber Prompt-Injection
                // oder einen manipulierten Speicherstand eingeschleustes
                // style="position:fixed;inset:0" haette die Shop-Seite
                // ueberdeckt. Die Beschreibungen brauchen nur Struktur
                // (Absaetze, Listen, Hervorhebungen), nie Attribute.
                for (const attr of Array.from(child.attributes)) {
                    child.removeAttribute(attr.name);
                }

                // Recursively clean children
                cleanNode(child);
            }
        }
    }

    cleanNode(temp);
    return temp.innerHTML;
}

// ============================================================================
// STATE VARIABLES
// ============================================================================

let pbValue = 0;
let pbTimer = null;
let messageTimer = null;
let loadingStartTime = null;
let alternativesCount = 0;
let _lastImageDataUri = null;
let currentRequestController = null;
let activeRequest = null; // Verhindert parallele Requests
let wakeLock = null; // Wake Lock für mobile Geräte

const DOM = {};

// ============================================================================
// WAKE LOCK (DEAKTIVIERT - verursachte Probleme auf Mobile)
// ============================================================================

async function acquireWakeLock() {
    // DEAKTIVIERT - Wake Lock verursachte JSON-Parsing-Probleme auf Mobile
    console.log('Wake Lock deaktiviert');
    return;
}

async function releaseWakeLock() {
    // DEAKTIVIERT
    return;
}

// ============================================================================
// JOB POLLING (für asynchrone Pipeline-Verarbeitung)
// ============================================================================

// Safari-Fix: Track abgeschlossene Jobs um Zombie-Polling zu verhindern
const _completedJobs = new Set();
let _activePollingJobId = null;

// Debug-Logging (nur Konsole, kann mit window.GP_DEBUG = true aktiviert werden)
function logPoll(level, ...args) {
    if (!window.GP_DEBUG && level !== 'error') return;
    const timestamp = new Date().toISOString().substr(11, 12);
    const prefix = `[GP ${timestamp}]`;
    if (level === 'error') {
        console.error(prefix, ...args);
    } else if (level === 'warn') {
        console.warn(prefix, ...args);
    } else {
        console.log(prefix, ...args);
    }
}

async function pollJobResult(jobId) {
    logPoll('important', '🚀 pollJobResult START', {
        jobId: jobId.substr(0, 8) + '...',
        completedJobs: _completedJobs.size,
        activePolling: _activePollingJobId?.substr(0, 8) || 'none',
        userAgent: navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome') ? 'Safari' : 'Other'
    });

    // Safari-Fix: Verhindere Polling für bereits abgeschlossene Jobs
    if (_completedJobs.has(jobId)) {
        logPoll('warn', '⛔ Job bereits abgeschlossen, überspringe:', jobId.substr(0, 8));
        localStorage.removeItem('pending_job_id');
        throw new Error('Job bereits verarbeitet.');
    }

    // Safari-Fix: Verhindere parallele Polling-Loops
    if (_activePollingJobId && _activePollingJobId !== jobId) {
        logPoll('warn', '⛔ Anderes Polling läuft bereits:', _activePollingJobId.substr(0, 8));
        throw new Error('Anderes Polling aktiv.');
    }
    _activePollingJobId = jobId;

    localStorage.setItem('pending_job_id', jobId);
    const baseUrl = getApiBaseUrl();
    const startTime = Date.now();
    let consecutiveNetworkErrors = 0;
    let currentInterval = CONFIG.POLL_INTERVAL_MS;
    let pollCount = 0;
    const MAX_POLLS = 120; // Absolutes Maximum: 120 Polls (ca. 6+ Minuten)

    // Hilfsfunktion: terminale Fehler bekommen ein Flag, damit der network-retry
    // sie nicht schluckt. Der bisherige String-Match auf fatalPhrases war fragil
    // (suchte z.B. "Fehler:" mit Doppelpunkt - die Backend-Message "Ein interner
    // Fehler ist aufgetreten..." enthält den aber nicht -> 5-Min-Zombie-Loop).
    const terminal = (message, extra = {}) => {
        const e = new Error(message);
        e.terminal = true;
        Object.assign(e, extra);
        return e;
    };

    while (true) {
        pollCount++;
        const elapsed = Date.now() - startTime;

        logPoll('info', `📡 Poll #${pollCount}`, {
            elapsed: Math.round(elapsed / 1000) + 's',
            interval: currentInterval + 'ms',
            netErrors: consecutiveNetworkErrors,
            visible: document.visibilityState
        });

        // Safari-Fix: Prüfe ob Job bereits abgeschlossen wurde (z.B. nach Tab-Wechsel)
        if (_completedJobs.has(jobId)) {
            logPoll('warn', '⛔ Safari-Resume: Job bereits abgeschlossen');
            _activePollingJobId = null;
            localStorage.removeItem('pending_job_id');
            throw new Error('Job bereits verarbeitet.');
        }

        // Timeout-Check: Maximale Polling-Dauer überschritten?
        if (elapsed > CONFIG.POLL_MAX_DURATION_MS) {
            logPoll('error', '⏰ Timeout erreicht:', Math.round(elapsed / 1000) + 's');
            _activePollingJobId = null;
            localStorage.removeItem('pending_job_id');
            throw new Error('Die Verarbeitung dauert zu lange. Bitte versuche es später erneut.');
        }

        // Absoluter Poll-Limit-Check (Schutz vor Endlosschleife)
        if (pollCount > MAX_POLLS) {
            logPoll('error', '🔄 Max Polls erreicht:', pollCount);
            _activePollingJobId = null;
            localStorage.removeItem('pending_job_id');
            throw new Error('Maximale Anzahl an Versuchen erreicht. Bitte neu starten.');
        }

        await sleep(currentInterval);

        // Nur Netzwerkschicht im try/catch - Job-States werden ausserhalb behandelt
        let data;
        try {
            const fetchStart = Date.now();
            const response = await fetch(`${baseUrl}/api/job/${jobId}`);
            const fetchDuration = Date.now() - fetchStart;

            logPoll('info', `📥 Response: ${response.status}`, {
                fetchMs: fetchDuration,
                contentLength: response.headers.get('content-length') || '?'
            });

            // HTTP-Fehler prüfen BEVOR wir JSON parsen
            if (!response.ok) {
                logPoll('error', '❌ HTTP-Fehler:', response.status);
                if (response.status === 404) {
                    throw terminal('Anfrage nicht mehr verfügbar. Bitte neu starten.');
                }
                if (response.status >= 500) {
                    // 5xx als transient - retry mit Backoff
                    throw new Error(`Server-Fehler (${response.status})`);
                }
                // Andere Client-Fehler: nicht wiederholbar
                throw terminal(`Fehler: ${response.status}`);
            }

            // JSON parsen - erst als Text laden für Debugging
            const contentLen = response.headers.get('content-length') || 0;
            logPoll('important', `🔄 Loading ${contentLen} bytes as text...`);

            let responseText;
            try {
                responseText = await response.text();
                logPoll('important', `📝 Got ${responseText.length} chars`, {
                    first50: responseText.substring(0, 50),
                    last50: responseText.substring(responseText.length - 50)
                });
            } catch (textErr) {
                logPoll('error', '💥 Response.text() failed:', textErr.message);
                throw new Error('Netzwerkfehler beim Laden der Antwort.');
            }

            const parseStart = Date.now();
            try {
                data = JSON.parse(responseText);
                const parseMs = Date.now() - parseStart;
                logPoll('important', `📋 JSON parsed in ${parseMs}ms`, {
                    status: data.status,
                    hasResult: !!data.result
                });
            } catch (parseErr) {
                // JSON-Parsing-Fehler - zeige wo der Fehler ist
                logPoll('error', '💥 JSON.parse failed:', parseErr.message);
                logPoll('error', '📄 Response length:', responseText.length);
                logPoll('error', '📄 First 200 chars:', responseText.substring(0, 200));
                logPoll('error', '📄 Last 200 chars:', responseText.substring(responseText.length - 200));

                // Prüfe ob HTML statt JSON
                if (responseText.trim().startsWith('<')) {
                    logPoll('error', '⚠️ Response is HTML, not JSON!');
                }

                throw terminal('Fehlerhafte Server-Antwort. Bitte neu starten.');
            }

            // Bei erfolgreichem Request: Netzwerkfehler-Zähler zurücksetzen
            consecutiveNetworkErrors = 0;
            currentInterval = CONFIG.POLL_INTERVAL_MS;
        } catch (err) {
            logPoll('warn', '⚠️ Catch block:', err.message);

            // Terminale Fehler sofort durchreichen - kein fragiler String-Match mehr
            if (err.terminal) {
                logPoll('error', '🛑 Terminal error, stopping:', err.message);
                _activePollingJobId = null;
                localStorage.removeItem('pending_job_id');
                throw err;
            }

            // Echte Netzwerk-/Server-Fehler: Zähler erhöhen und mit Backoff weiterpollen
            consecutiveNetworkErrors++;
            logPoll('warn', `🔄 Retry ${consecutiveNetworkErrors}/${CONFIG.POLL_MAX_NETWORK_ERRORS}:`, err.message);

            if (consecutiveNetworkErrors >= CONFIG.POLL_MAX_NETWORK_ERRORS) {
                logPoll('error', '🛑 Max network errors reached');
                _activePollingJobId = null;
                localStorage.removeItem('pending_job_id');
                throw new Error('Verbindungsprobleme. Bitte Internetverbindung prüfen und erneut versuchen.');
            }

            // Exponential Backoff bei Netzwerkfehlern (max 15 Sekunden)
            const oldInterval = currentInterval;
            currentInterval = Math.min(
                currentInterval * CONFIG.POLL_BACKOFF_MULTIPLIER,
                15000
            );
            logPoll('info', `⏱️ Backoff: ${oldInterval}ms → ${currentInterval}ms`);
            continue;
        }

        // Terminale Job-States ausserhalb des try - kein Network-Retry mehr moeglich
        if (data.status === 'completed') {
            logPoll('important', '✅ JOB COMPLETED!', {
                totalPolls: pollCount,
                totalTime: Math.round((Date.now() - startTime) / 1000) + 's'
            });
            // Safari-Fix: Job als abgeschlossen markieren BEVOR wir returnen
            _completedJobs.add(jobId);
            _activePollingJobId = null;
            localStorage.removeItem('pending_job_id');
            logPoll('important', '🏁 Returning result now...');
            return data.result;
        }
        if (data.status === 'failed') {
            logPoll('error', '❌ Job failed:', data.error);
            _activePollingJobId = null;
            localStorage.removeItem('pending_job_id');
            const e = new Error(data.error || 'Unbekannter Fehler');
            e.errorCode = data.error_code || 'internal';
            throw e;
        }
        if (data.status === 'not_found') {
            logPoll('error', '🔍 Job not found');
            _activePollingJobId = null;
            localStorage.removeItem('pending_job_id');
            throw new Error('Anfrage nicht mehr verfügbar. Bitte neu starten.');
        }
        // status === 'processing' oder 'pending': weiterpollen
        logPoll('info', `⏳ Status: ${data.status}`, { progress: data.progress, message: data.message });
    }
}

function cacheDOMElements() {
    DOM.description = document.getElementById('description');
    DOM.plantingMode = document.getElementById('plantingMode');
    DOM.fileInput = document.getElementById('gardenImage');
    DOM.fileName = document.getElementById('fileName');
    DOM.deleteBtn = document.getElementById('deleteFileBtn');
    DOM.fileDrop = document.getElementById('fileDrop');
    DOM.submitBtn = document.getElementById('submitBtn');
    DOM.loadingDiv = document.getElementById('loadingDiv');
    DOM.loadingText = document.querySelector('.loading-text');
    DOM.loadingHint = document.querySelector('.loading-hint');
    DOM.progressBarInner = document.querySelector('.progress-bar-inner');
    DOM.results = document.getElementById('results');
    DOM.errorBox = document.getElementById('errorBox');
    DOM.errorMessage = document.getElementById('errorMessage');
    DOM.imageGrid = document.getElementById('imageGrid');
    DOM.plantAccordions = document.getElementById('plantAccordions');
    DOM.inputSection = document.getElementById('inputSection');
    DOM.starterChips = document.getElementById('starterChips');
    DOM.pdfDownloadBtn = document.getElementById('pdfDownloadBtn');
    DOM.refreshBtn = document.getElementById('refreshBtn');
    DOM.retryBtn = document.getElementById('retryBtn');
    DOM.createAdditionalBtn = document.getElementById('createAdditionalBtn');
    DOM.refineDrawer = document.getElementById('refineDrawer');
    DOM.closeRefineBtn = document.getElementById('closeRefineBtn');
    DOM.refineChips = document.getElementById('refineChips');
    DOM.refineText = document.getElementById('refineText');
    DOM.runRefineBtn = document.getElementById('runRefineBtn');
    DOM.refineLoadingDiv = document.getElementById('refineLoadingDiv');
}

function getApiUrl() {
    const el = document.getElementById('apiUrl');
    return el ? el.value : 'https://api.baumfink.de/api/plan_garden';
}

function getApiBaseUrl() {
    // Extrahiere Base-URL aus der API-URL (ohne /api/plan_garden)
    const apiUrl = getApiUrl();
    return apiUrl.replace('/api/plan_garden', '');
}

// ============================================================================
// UTILITY FUNCTIONS
// ============================================================================

function toast(message, bg) {
    const n = document.createElement('div');
    n.className = 'toast';
    n.style.background = bg || CONFIG.COLORS.success;
    n.textContent = message;
    document.getElementById('gp-planner').appendChild(n);
    setTimeout(() => {
        n.style.animation = 'slideOut .2s ease';
        setTimeout(() => n.remove(), 200);
    }, 2500);
}

// Der "im Warenkorb"-Zustand haengt am ENTWURF, nicht an der Position in der
// Liste. Frueher wurde nur der Alternativen-Index gespeichert - und der ist
// immer 1, weil das Backend genau einen Entwurf liefert. In Verbindung mit
// localStorage (kein Ablauf) blieb der Button dadurch fuer immer grau, sobald
// ein Nutzer irgendwann einmal etwas in den Warenkorb gelegt hatte.
//
// Schluessel ist jetzt die sortierte Liste der Variant-IDs des Entwurfs. Damit
// ist der Zustand automatisch pro Entwurf, und er laesst sich gegen den echten
// Warenkorb pruefen.

function getAlternativeVariantIds(alternative) {
    if (!Array.isArray(alternative)) return [];
    return alternative
        .filter(row => row && row.Pflanze !== 'SUMME' && row.variant_id)
        // variant_id kommt je nach Alter der Daten als Zahl oder als
        // Zeichenkette mit ".0" (siehe Backend-Befund A.0/C.6).
        .map(row => String(row.variant_id).replace(/\.0$/, '').trim())
        .filter(Boolean)
        .sort();
}

// B4: der Schluessel traegt jetzt auch die STUECKZAHL.
//
// Bis zum 04.09. lag der "im Warenkorb"-Vermerk unter dem Index der
// Alternative - und der ist immer 1 -, im localStorage und damit ohne Ablauf;
// der Button blieb fuer immer grau. Behoben wurde das mit der sortierten
// Variant-ID-Liste als Schluessel.
//
// Seit der Kunde die Stueckzahlen bearbeiten kann, reicht das nicht mehr:
// aendert er NUR Mengen, bleibt die ID-Menge identisch, der alte Vermerk
// trifft weiter zu und der Button bleibt grau - obwohl seine Liste jetzt
// andere Mengen hat als der Warenkorb. Das waere derselbe behobene Fehler
// durch eine andere Tuer.
function getAlternativeMengen(alternative) {
    if (!Array.isArray(alternative)) return [];
    return alternative
        .filter(row => row && row.Pflanze !== 'SUMME' && row.variant_id)
        .map(row => {
            const id = String(row.variant_id).replace(/\.0$/, '').trim();
            const anzahl = parseInt(row.Anzahl, 10);
            return id ? `${id}:${isFinite(anzahl) ? anzahl : 0}` : '';
        })
        .filter(Boolean)
        .sort();
}

function getAlternativeKey(altIndex) {
    const alt = (window.plantAlternatives || [])[altIndex - 1];
    const mengen = getAlternativeMengen(alt);
    return mengen.length ? mengen.join(',') : '';
}

function readAddedKeys() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEYS.addedCart);
        const list = JSON.parse(raw || '[]');
        return Array.isArray(list) ? list : [];
    } catch (e) {
        return [];
    }
}

function markAlternativeAsAdded(altIndex) {
    const key = getAlternativeKey(altIndex);
    if (!key) return;
    const added = readAddedKeys();
    if (!added.includes(key)) {
        added.push(key);
        try {
            sessionStorage.setItem(STORAGE_KEYS.addedCart, JSON.stringify(added));
        } catch (e) { /* Speicher voll oder gesperrt - nicht kritisch */ }
    }
}

function isAlternativeAdded(altIndex) {
    const key = getAlternativeKey(altIndex);
    return !!key && readAddedKeys().includes(key);
}

function clearAddedAlternatives() {
    try {
        sessionStorage.removeItem(STORAGE_KEYS.addedCart);
    } catch (e) { /* egal */ }
}

// ============================================================================
// FETCH WITH RETRY (Verbessert - nur Netzwerkfehler)
// ============================================================================

// Custom Error für Rate Limiting
class RateLimitError extends Error {
    constructor(message, reason, waitSeconds) {
        super(message);
        this.name = 'RateLimitError';
        this.reason = reason;
        this.waitSeconds = waitSeconds;
    }
}

async function fetchWithRetry(url, options, retries = CONFIG.MAX_RETRIES) {
    currentRequestController = new AbortController();
    const timeoutId = setTimeout(() => {
        currentRequestController.abort();
    }, CONFIG.REQUEST_TIMEOUT_MS);

    try {
        const response = await fetch(url, {
            ...options,
            signal: currentRequestController.signal
        });

        clearTimeout(timeoutId);
        currentRequestController = null;

        // Spezielle Behandlung für Rate Limiting (HTTP 429)
        if (response.status === 429) {
            const errorData = await response.json().catch(() => ({}));
            console.log('🚫 Rate Limit erreicht:', errorData);
            throw new RateLimitError(
                errorData.error || 'Zu viele Anfragen. Bitte warten.',
                errorData.rate_limit_reason || 'unknown',
                errorData.wait_seconds || 0
            );
        }

        if (!response.ok) {
            // KEIN Retry bei Server-Fehlern (4xx, 5xx)
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `Server Error: ${response.status}`);
        }

        return response;

    } catch (error) {
        clearTimeout(timeoutId);
        currentRequestController = null;

        // Rate Limit Fehler nicht retrien, direkt weiterwerfen
        if (error instanceof RateLimitError) {
            throw error;
        }

        // Bei Abort (Timeout) - KEIN Retry
        if (error.name === 'AbortError') {
            console.log(`⏱️ Timeout nach ${CONFIG.REQUEST_TIMEOUT_MS/1000}s`);
            throw new Error('Die Anfrage hat zu lange gedauert. Bitte versuche es erneut.');
        }

        // NUR bei Netzwerkfehlern retrien
        const isNetworkError = error.message.includes('Failed to fetch') ||
                               error.message.includes('NetworkError') ||
                               error.message.includes('network');

        if (isNetworkError && retries > 0) {
            console.log(`🌐 Netzwerkfehler, Retry ${CONFIG.MAX_RETRIES - retries + 1}/${CONFIG.MAX_RETRIES}`);
            toast(`Verbindungsproblem, versuche erneut... (${CONFIG.MAX_RETRIES - retries + 1}/${CONFIG.MAX_RETRIES})`, '#f59e0b');

            // Exponentielles Backoff: 2s, 4s
            const delay = (CONFIG.MAX_RETRIES - retries + 1) * 2000;
            console.log(`⏳ Warte ${delay/1000}s vor erneutem Versuch...`);
            await new Promise(resolve => setTimeout(resolve, delay));

            return fetchWithRetry(url, options, retries - 1);
        }

        throw error;
    }
}

// Hilfsfunktion für Rate Limit Fehlerbehandlung
function handleRateLimitError(error) {
    if (error instanceof RateLimitError) {
        const reason = error.reason;
        let toastMessage = error.message;
        let toastColor = '#f59e0b'; // Orange/Warning

        if (reason === 'duplicate_pending') {
            toastMessage = '⏳ Deine Anfrage wird bereits verarbeitet...';
            toastColor = '#3b82f6'; // Blau/Info
        } else if (reason === 'cooldown' && error.waitSeconds > 0) {
            toastMessage = `⏳ Bitte warte noch ${error.waitSeconds} Sekunden`;
            // Optional: Countdown anzeigen
            startCooldownCountdown(error.waitSeconds);
        } else if (reason === 'max_concurrent') {
            toastMessage = '⏳ Eine Anfrage läuft bereits...';
            toastColor = '#3b82f6';
        }

        toast(toastMessage, toastColor);
        return true; // Wurde behandelt
    }
    return false; // Nicht behandelt
}

// Cooldown Countdown anzeigen
let cooldownInterval = null;
function startCooldownCountdown(seconds) {
    if (cooldownInterval) clearInterval(cooldownInterval);

    let remaining = seconds;
    const updateButton = () => {
        if (DOM.submitBtn && DOM.submitBtn.disabled) {
            DOM.submitBtn.textContent = `Bitte warten (${remaining}s)...`;
        }
    };

    updateButton();
    cooldownInterval = setInterval(() => {
        remaining--;
        if (remaining <= 0) {
            clearInterval(cooldownInterval);
            cooldownInterval = null;
            if (DOM.submitBtn) {
                DOM.submitBtn.textContent = DOM.submitBtn.dataset.originalText || 'Gartenplan erstellen';
                DOM.submitBtn.disabled = false;
                DOM.submitBtn.classList.remove('loading');
            }
            toast('Du kannst jetzt eine neue Anfrage senden', '#2FAE55');
        } else {
            updateButton();
        }
    }, 1000);
}

// ============================================================================
// IMAGE PROCESSING
// ============================================================================

function isImageLikeString(s) {
    if (typeof s !== 'string') return false;
    if (/^data:image\//i.test(s)) return true;
    if (/^https?:\/\//i.test(s) && /\.(png|jpe?g|webp)(\?|#|$)/i.test(s)) return true;
    return false;
}

function pickFromObj(o) {
    if (!o || typeof o !== 'object') return null;
    return o.data_uri || o.dataURL || o.dataUrl || o.url || o.src || o.image || null;
}

function deepCollectImages(node, acc, limit = 12) {
    if (acc.length >= limit || !node) return;

    if (Array.isArray(node)) {
        node.forEach(n => deepCollectImages(n, acc, limit));
        return;
    }

    if (typeof node === 'string') {
        if (isImageLikeString(node)) acc.push(node);
        return;
    }

    if (typeof node === 'object') {
        const direct = pickFromObj(node);
        if (direct && isImageLikeString(String(direct))) acc.push(String(direct));

        for (const k in node) {
            if (!Object.prototype.hasOwnProperty.call(node, k)) continue;
            deepCollectImages(node[k], acc, limit);
            if (acc.length >= limit) break;
        }
    }
}

function normalizeImages(raw) {
    let candidates = raw?.image_data_uris || raw?.images || raw?.image_urls || raw?.generated_images || raw?.outputs || [];
    let list = [];

    if (Array.isArray(candidates) && candidates.length) {
        list = candidates.map(it => {
            if (typeof it === 'string') return it;
            const p = pickFromObj(it);
            return p || null;
        }).filter(Boolean);
    }

    if (list.length === 0) {
        const acc = [];
        deepCollectImages(raw, acc, 12);
        list = acc;
    }

    const seen = new Set();
    const out = [];
    list.forEach(s => {
        if (!isImageLikeString(String(s))) return;
        const key = String(s);
        if (!seen.has(key)) {
            seen.add(key);
            out.push(String(s));
        }
    });

    return out;
}

// ============================================================================
// SIMPLE IMAGE ZOOM (Shopify-Style)
// ============================================================================

function initImageZoom() {
    // Ein eigener Knopf statt des ganzen Bildes: das Ziehen am Vergleichsgriff
    // und das Antippen zum Vergrossern waeren sonst dieselbe Geste, und ein
    // Bewegungs-Schwellwert dafuer ist genau die Sorte Code, die auf einem
    // Geraet funktioniert und auf dem naechsten nicht.
    document.querySelectorAll('.bild-lupe').forEach(knopf => {
        if (knopf.dataset.verdrahtet === 'ja') return;
        knopf.dataset.verdrahtet = 'ja';
        knopf.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const buehne = knopf.closest('.bild-buehne');
            const bild = buehne && buehne.querySelector('.thumb');
            if (!bild) return;
            const altIdx = parseInt(buehne.dataset.altIndex, 10);
            const vorher = buehne.querySelector('.vorher-bild');
            openZoomOverlay(bild.src, bild.alt || 'Gartenplan',
                            vorher ? vorher.src : null);
        });
    });

    // Aeltere gespeicherte Staende koennen noch Karten mit dem alten Aufbau
    // enthalten. Die bleiben bedienbar.
    document.querySelectorAll('.pswp-link').forEach(link => {
        if (link.dataset.verdrahtet === 'ja') return;
        link.dataset.verdrahtet = 'ja';
        link.addEventListener('click', (e) => {
            e.preventDefault();
            openZoomOverlay(link.getAttribute('href'),
                            link.querySelector('img')?.alt || 'Gartenplan');
        });
    });
}

function openZoomOverlay(src, alt, vorherSrc) {
    // SECURITY: Validate image source and escape alt text
    const rawSrc = String(src);
    let safeSrc = '';
    if (rawSrc.startsWith('data:image/')) {
        safeSrc = rawSrc; // Base64 image data URI is safe
    } else {
        safeSrc = sanitizeUrl(rawSrc);
    }
    const safeAlt = escapeHtml(alt);

    const overlay = document.createElement('div');
    overlay.className = 'zoom-overlay';
    // In der Vergroesserung wird NICHT gezogen, sondern umgeschaltet. Ein
    // Griff neben Pinch-Zoom waeren zwei Gestensysteme auf demselben Element;
    // der Umschalter laesst Zoom und Verschiebung unangetastet, und der Kunde
    // vergleicht an genau der Stelle, die er sich gerade herangeholt hat.
    const safeVorher = vorherSrc && String(vorherSrc).startsWith('data:image/')
        ? String(vorherSrc) : '';
    const umschalter = safeVorher
        ? `<button class="zoom-umschalter" type="button" aria-pressed="false">Vorher ansehen</button>`
        : '';

    overlay.innerHTML = `
        <div class="zoom-overlay-bg"></div>
        <button class="zoom-close" aria-label="Schließen">×</button>
        <div class="zoom-container">
            <img src="${safeSrc}" alt="${safeAlt}" class="zoom-image">
        </div>
        ${umschalter}
    `;

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    const img = overlay.querySelector('.zoom-image');
    const container = overlay.querySelector('.zoom-container');
    const closeBtn = overlay.querySelector('.zoom-close');
    const bg = overlay.querySelector('.zoom-overlay-bg');

    let scale = 1;
    let panning = false;
    let pointX = 0;
    let pointY = 0;
    let start = { x: 0, y: 0 };

    function setTransform() {
        img.style.transform = `translate(${pointX}px, ${pointY}px) scale(${scale})`;
    }

    // Double-click zoom
    img.addEventListener('dblclick', (e) => {
        if (scale === 1) {
            scale = 2.5;
            const rect = img.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            pointX = (rect.width / 2 - x) * 1.5;
            pointY = (rect.height / 2 - y) * 1.5;
        } else {
            scale = 1;
            pointX = 0;
            pointY = 0;
        }
        setTransform();
    });

    // Mouse wheel zoom
    container.addEventListener('wheel', (e) => {
        e.preventDefault();
        const xs = (e.clientX - pointX) / scale;
        const ys = (e.clientY - pointY) / scale;
        const delta = e.deltaY > 0 ? -0.2 : 0.2;
        scale = Math.min(Math.max(1, scale + delta), 4);
        pointX = e.clientX - xs * scale;
        pointY = e.clientY - ys * scale;
        if (scale === 1) {
            pointX = 0;
            pointY = 0;
        }
        setTransform();
    }, { passive: false });

    // Pan
    img.addEventListener('mousedown', (e) => {
        if (scale > 1) {
            e.preventDefault();
            start = { x: e.clientX - pointX, y: e.clientY - pointY };
            panning = true;
            img.style.cursor = 'grabbing';
        }
    });

    window.addEventListener('mousemove', (e) => {
        if (!panning) return;
        e.preventDefault();
        pointX = e.clientX - start.x;
        pointY = e.clientY - start.y;
        setTransform();
    });

    window.addEventListener('mouseup', () => {
        panning = false;
        img.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    });

    // Touch support
    let initialDistance = 0;
    let initialScale = 1;

    container.addEventListener('touchstart', (e) => {
        if (e.touches.length === 2) {
            e.preventDefault();
            initialDistance = Math.hypot(
                e.touches[0].pageX - e.touches[1].pageX,
                e.touches[0].pageY - e.touches[1].pageY
            );
            initialScale = scale;
        } else if (e.touches.length === 1 && scale > 1) {
            start = {
                x: e.touches[0].clientX - pointX,
                y: e.touches[0].clientY - pointY
            };
            panning = true;
        }
    }, { passive: false });

    container.addEventListener('touchmove', (e) => {
        if (e.touches.length === 2) {
            e.preventDefault();
            const distance = Math.hypot(
                e.touches[0].pageX - e.touches[1].pageX,
                e.touches[0].pageY - e.touches[1].pageY
            );
            scale = Math.min(Math.max(1, initialScale * (distance / initialDistance)), 4);
            setTransform();
        } else if (panning && e.touches.length === 1) {
            e.preventDefault();
            pointX = e.touches[0].clientX - start.x;
            pointY = e.touches[0].clientY - start.y;
            setTransform();
        }
    }, { passive: false });

    container.addEventListener('touchend', () => {
        panning = false;
        if (scale === 1) {
            pointX = 0;
            pointY = 0;
            setTransform();
        }
    });

    // Close
    const closeOverlay = () => {
        overlay.remove();
        document.body.style.overflow = '';
    };

    const umschaltKnopf = overlay.querySelector('.zoom-umschalter');
    if (umschaltKnopf) {
        let zeigtVorher = false;
        umschaltKnopf.addEventListener('click', (e) => {
            e.stopPropagation();
            zeigtVorher = !zeigtVorher;
            // Nur die Quelle tauschen - transform bleibt stehen, damit
            // Ausschnitt und Vergroesserung erhalten bleiben.
            img.src = zeigtVorher ? safeVorher : safeSrc;
            umschaltKnopf.textContent = zeigtVorher ? 'Entwurf ansehen' : 'Vorher ansehen';
            umschaltKnopf.setAttribute('aria-pressed', zeigtVorher ? 'true' : 'false');
            overlay.classList.toggle('zeigt-vorher', zeigtVorher);
        });
    }

    closeBtn.addEventListener('click', closeOverlay);
    bg.addEventListener('click', closeOverlay);

    document.addEventListener('keydown', function escClose(e) {
        if (e.key === 'Escape') {
            closeOverlay();
            document.removeEventListener('keydown', escClose);
        }
    });

    // Animate in
    setTimeout(() => overlay.classList.add('active'), 10);
}

// ============================================================================
// PROGRESS BAR - Zeitbasiert (nicht progress-basiert)
// ============================================================================

// B: welche Meldungsfolge gerade laeuft. Wird von startProgress() gesetzt und
// von doneProgress()/resetProgress() zurueckgestellt, damit ein Neuentwurf
// nicht "Gartenfoto wird hochgeladen" anzeigt.
let aktiveMeldungen = CONFIG.LOADING_MESSAGES;

function updateLoadingMessage() {
    if (!loadingStartTime || !DOM.loadingText) return;

    const elapsed = Date.now() - loadingStartTime;
    const meldungen = aktiveMeldungen || CONFIG.LOADING_MESSAGES;

    // Finde die passende Nachricht basierend auf verstrichener Zeit
    let currentMessage = meldungen[0].text;
    for (let i = meldungen.length - 1; i >= 0; i--) {
        if (elapsed >= meldungen[i].minTime) {
            currentMessage = meldungen[i].text;
            break;
        }
    }

    DOM.loadingText.textContent = currentMessage;
}

function setProgress(p) {
    if (!DOM.progressBarInner) return;
    pbValue = Math.max(pbValue, Math.min(p, 1));
    DOM.progressBarInner.style.width = Math.round(pbValue * 100) + '%';
}

function bumpProgress(delta, cap = 0.95) {
    const next = Math.min(pbValue + delta, cap);
    setProgress(next);
}

function startProgress(duration = CONFIG.TOTAL_DURATION_MS, meldungen) {
    pbValue = 0;
    loadingStartTime = Date.now();
    aktiveMeldungen = meldungen || CONFIG.LOADING_MESSAGES;
    setProgress(0.02);
    updateLoadingMessage();

    if (pbTimer) clearInterval(pbTimer);
    if (messageTimer) clearInterval(messageTimer);

    // Progress-Bar Animation - smooth und realistisch
    pbTimer = setInterval(() => {
        const elapsed = Date.now() - loadingStartTime;
        const progressRatio = elapsed / duration;

        // Logarithmische Kurve für realistischeren Fortschritt
        // Schnell am Anfang, langsamer zum Ende
        let targetProgress;
        if (progressRatio < 0.3) {
            // Erste 30% der Zeit: bis 50% Fortschritt
            targetProgress = progressRatio * 1.67;
        } else if (progressRatio < 0.6) {
            // 30-60% der Zeit: 50-75% Fortschritt
            targetProgress = 0.5 + ((progressRatio - 0.3) * 0.83);
        } else {
            // 60-100% der Zeit: 75-95% Fortschritt (langsam)
            targetProgress = 0.75 + ((progressRatio - 0.6) * 0.5);
        }

        targetProgress = Math.min(0.95, targetProgress);

        // Sanfte Animation zum Zielwert
        if (pbValue < targetProgress) {
            const step = (targetProgress - pbValue) * 0.12;
            setProgress(pbValue + Math.max(step, 0.003));
        }
    }, 100);

    // Nachrichten-Timer - unabhängig vom Progress
    messageTimer = setInterval(updateLoadingMessage, 500);
}

function reach(progress) {
    if (pbTimer) {
        clearInterval(pbTimer);
        pbTimer = null;
    }
    setProgress(progress);
}

function doneProgress() {
    if (pbTimer) {
        clearInterval(pbTimer);
        pbTimer = null;
    }
    if (messageTimer) {
        clearInterval(messageTimer);
        messageTimer = null;
    }
    setProgress(1);
    if (DOM.loadingText) {
        DOM.loadingText.textContent = "Fertig! 🎉";
    }
}

function resetProgress() {
    if (pbTimer) {
        clearInterval(pbTimer);
        pbTimer = null;
    }
    if (messageTimer) {
        clearInterval(messageTimer);
        messageTimer = null;
    }
    pbValue = 0;
    loadingStartTime = null;
    aktiveMeldungen = CONFIG.LOADING_MESSAGES;
    setProgress(0);
    if (DOM.loadingText) {
        DOM.loadingText.textContent = "Der Gartenplan wird erstellt.";
    }
    if (DOM.loadingHint) {
        DOM.loadingHint.textContent = "Dies kann bis zu 2 Minuten dauern.";
    }
}

// ============================================================================
// TABLE GENERATION
// ============================================================================

// B4: Stueckzahlen sind bearbeitbar (altIdx gesetzt), sonst nur Anzeige.
// Die Anzahl-Zelle bekommt Minus, Zahl und Plus; runter bis 0 heisst
// "Pflanze entfernen". Gerechnet wird NICHTS im Browser - Preise und Summe
// kommen beim Neuerzeugen serverseitig zurueck. Der Browser haelt nur, was
// der Kunde eingestellt hat.
function generatePlantTable(alternative, altIdx) {
    if (!alternative || alternative.length === 0) {
        return '<p>Keine Pflanzen verfügbar</p>';
    }

    const bearbeitbar = Number.isInteger(altIdx);

    let html = `<div class="table-scroll-wrapper"><table><thead><tr><th>Pflanze</th><th>Anzahl</th><th>Einzelpreis</th><th>Gesamt</th></tr></thead><tbody>`;

    alternative.forEach((row, zeilenNr) => {
        const isSumRow = row.Pflanze === 'SUMME';
        // SECURITY: Escape all text content to prevent XSS
        const displayName = escapeHtml(row.display_name || row.Pflanze || '-');
        const safeUrl = sanitizeUrl(row.product_url);
        const hasLink = safeUrl && !isSumRow;

        const plantNameCell = hasLink
            ? `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer" class="plant-link" title="Zum Produkt">${displayName}</a>`
            : displayName;

        // Zeilen, die der Kunde selbst aufgenommen hat, sagen das auch. Sonst
        // sieht seine Auswahl aus wie ein Vorschlag des Planers.
        const herkunft = (!isSumRow && row.source === 'manual')
            ? '<span class="zeile-herkunft">von dir gewählt</span>'
            : '';

        let anzahlZelle;
        if (isSumRow) {
            anzahlZelle = '';
        } else if (bearbeitbar && row.variant_id) {
            const anzahl = parseInt(row.Anzahl, 10);
            const wert = isFinite(anzahl) ? anzahl : 0;
            // data-Attribute statt inline-Zustand: die Werte werden beim
            // Neuerzeugen wieder aus dem DOM gelesen.
            anzahlZelle =
                `<div class="mengen-stepper" data-alt-index="${altIdx}" data-zeile="${zeilenNr}">` +
                `<button type="button" class="stepper-btn" data-schritt="-1"` +
                ` aria-label="Weniger ${displayName}">−</button>` +
                `<span class="stepper-wert" data-variant-id="${escapeHtml(String(row.variant_id))}">${wert}</span>` +
                `<button type="button" class="stepper-btn" data-schritt="1"` +
                ` aria-label="Mehr ${displayName}">+</button>` +
                `</div>`;
        } else {
            anzahlZelle = escapeHtml(row.Anzahl) || '-';
        }

        // Die Suchzeile steht zwischen letzter Pflanze und Summe - da, wo
        // der Gedanke "hier fehlt noch etwas" entsteht.
        if (isSumRow && bearbeitbar) {
            html += sucheZeile(altIdx);
        }

        html += `
            <tr class="${isSumRow ? 'sum-row' : ''}">
                <td>${isSumRow ? 'SUMME' : plantNameCell}${isSumRow ? '' : herkunft}</td>
                <td>${anzahlZelle}</td>
                <td>${escapeHtml(row.Einzelpreis) || (isSumRow ? '' : '-')}</td>
                <td>${escapeHtml(row.Gesamt) || '-'}</td>
            </tr>`;
    });

    // Listen ohne Summenzeile (aelterer gespeicherter Stand): dann haengt die
    // Suchzeile hinten an, statt ganz zu fehlen.
    if (bearbeitbar && !alternative.some(r => r && r.Pflanze === 'SUMME')) {
        html += sucheZeile(altIdx);
    }

    html += `</tbody></table></div>`;
    return html;
}

// Die Suche ist eine Tabellenzeile, keine eigene Box: gleiche Spaltenbreiten,
// gleicher Rhythmus. Anzahl, Einzelpreis und Gesamt bleiben leer - hier steht
// noch nichts, was gerechnet werden koennte.
function sucheZeile(altIdx) {
    return `
            <tr class="such-zeile">
                <td><input type="text" class="such-feld" data-alt-index="${altIdx}"
                    placeholder="${escapeHtml(CONFIG.SUCHE_PLATZHALTER)}"
                    aria-label="Pflanze aus dem Katalog hinzufügen"
                    autocomplete="off" role="combobox" aria-expanded="false"
                    aria-autocomplete="list" aria-controls="gp-such-liste-${altIdx}"></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>`;
}

// ============================================================================
// RENDER FUNCTIONS
// ============================================================================

function renderImageCard(imgDataUri, title, altIdx) {
    // Immer im aktiven Zustand rendern. Ob der Entwurf schon im Warenkorb liegt,
    // entscheidet syncCartButtons() nach dem Rendern anhand des echten
    // Warenkorbs - beim Rendern steht window.plantAlternatives noch gar nicht,
    // die Variant-IDs sind hier also nicht bekannt.
    const btnClass = 'btn-primary btn-aktion btn-add-to-cart';
    const btnText = 'In den Warenkorb';
    const btnDisabled = '';
    const btnDataAdded = '';

    // SECURITY: Validate image source (allow data: URIs for base64 images and https)
    const rawSrc = String(imgDataUri);
    let src = '';
    if (rawSrc.startsWith('data:image/')) {
        src = rawSrc; // Base64 image data URI is safe
    } else {
        src = sanitizeUrl(rawSrc); // Validate external URLs
    }

    // SECURITY: Escape title to prevent XSS
    const safeTitle = escapeHtml(title);

    const card = document.createElement('div');
    card.className = 'image-card';
    card.setAttribute('data-alt-index', altIdx);

    // Die Klasse `thumb` bleibt am ERZEUGTEN Bild. generatePDF() liest
    // card.querySelector('.thumb').src - traegt sie das Foto, landet das
    // Vorher-Bild im PDF, ohne dass irgendetwas fehlschlaegt.
    //
    // Der Zoom haengt am Lupenknopf, nicht mehr am Bild selbst. Vorher war das
    // ganze Bild ein <a> mit der Data-URI als href; das war fuer Vorlesegeraete
    // ein "Link zu Bild", auf dem Telefon ohne jeden Hinweis, und es kollidiert
    // mit dem Ziehen des Vergleichsgriffs.
    card.innerHTML = `
        <div class="bild-buehne" data-alt-index="${altIdx}">
            <img class="thumb" loading="lazy" src="${src}" alt="${safeTitle}">
            <span class="gp-wuchsmarke">in 3&ndash;5 Jahren</span>
            <button type="button" class="bild-lupe" aria-label="Bild vergrößern"
                title="Bild vergrößern"><span aria-hidden="true">⌕</span></button>
        </div>
        <h4>${safeTitle}</h4>
        <div style="display:flex; gap:10px; justify-content:center; margin-top:8px;">
            <button type="button" class="${btnClass}" ${btnDisabled} ${btnDataAdded} data-aktion="warenkorb" data-alt-index="${altIdx}">${btnText}</button>
        </div>
    `;

    return card;
}

// A3: Hinweise zu Wunschpflanzen, die nicht im Entwurf sind.
//
// Kommt als eigenes Feld `pflanzenhinweise` aus dem Backend, nicht als Satz im
// Beschreibungstext. Der fertige Satz steht in `text` und wird hier NICHT
// zusammengebaut - der Wortlaut liegt serverseitig in data/hinweistexte.json
// und soll ohne Frontend-Rollout aenderbar bleiben.
//
// Drei Auspraegungen:
//   nicht_im_sortiment   Satz + Link auf die Ersatzpflanze aus dem Entwurf
//   nicht_lieferbar      Satz + Link auf den Artikel selbst
//   standort_ungeeignet  nur der Satz
function renderPflanzenhinweise(hinweise) {
    if (!Array.isArray(hinweise) || hinweise.length === 0) return '';

    const zeilen = hinweise.map(h => {
        if (!h || !h.text) return '';
        // SECURITY: Text kommt vom Server, wird aber wie jede andere
        // Fremdzeichenkette escaped - dieselbe Regel wie in generatePlantTable().
        const text = escapeHtml(h.text);
        const status = String(h.status || '').replace(/[^a-z_]/g, '');

        // Der Ersatzname steht schon IM Satz ("... ist X im Entwurf"). Ihn
        // dort zu verlinken ist besser als ihn dahinter zu wiederholen.
        // Faellt der Name aus dem Satz - der Betreiber darf den Wortlaut in
        // data/hinweistexte.json aendern -, wird der Link angehaengt statt
        // stillschweigend zu verschwinden.
        const anhaengen = (inhalt, url, beschriftung) => {
            const sicher = sanitizeUrl(url);
            if (!sicher) return inhalt;
            const name = escapeHtml(beschriftung);
            const anker = `<a href="${sicher}" target="_blank" rel="noopener noreferrer"` +
                          ` class="hinweis-link">${name}</a>`;
            return inhalt.includes(name) ? inhalt.replace(name, anker) : `${inhalt} ${anker}`;
        };

        let inhalt = text;
        if ((h.status === 'nicht_lieferbar' || h.status === 'nicht_aufgenommen') && h.artikel) {
            // Hier traegt der Satz den WUNSCHnamen, nicht den Artikelnamen -
            // der Link haengt sich also regulaer hinten an.
            inhalt = anhaengen(inhalt, h.artikel.product_url,
                               h.artikel.link_text || 'Zum Artikel');
        } else if (h.status === 'nicht_im_sortiment' && h.ersatz) {
            inhalt = anhaengen(inhalt, h.ersatz.product_url, h.ersatz.display_name);
        }

        return `<li class="pflanzenhinweis pflanzenhinweis-${status}">${inhalt}</li>`;
    }).filter(Boolean);

    if (zeilen.length === 0) return '';

    return `<div class="pflanzenhinweise" role="note">
        <div class="pflanzenhinweise-titel">Zu deinen Wunschpflanzen</div>
        <ul>${zeilen.join('')}</ul>
    </div>`;
}

// B4: Leiste unter der Stueckliste. Der Zaehler wird nur GESPIEGELT -
// durchgesetzt wird die Grenze serverseitig in /api/regenerate, sonst
// genuegte ein manipulierter Browser.
// Der Knopf ist gesperrt, solange nichts geaendert wurde.
//
// Ein Klick auf die unveraenderte Liste erzeugt keinen anderen Entwurf, kostet
// aber einen der drei Neuentwuerfe und eine Bildgenerierung. Der Knopf wird
// erst zur Handlung, wenn es etwas zu uebernehmen gibt.
//
// Verglichen wird gegen den Stand, MIT DEM der Entwurf erzeugt wurde - nicht
// gegen "hat schon mal jemand geklickt". Wer eine Menge hoch- und wieder
// runterstellt, hat nichts geaendert, und der Knopf geht korrekt wieder aus.
function mengenSchluessel(liste) {
    if (!Array.isArray(liste)) return '';
    return liste
        .filter(row => row && row.Pflanze !== 'SUMME' && row.variant_id)
        .map(row => {
            const id = String(row.variant_id).replace(/\.0$/, '').trim();
            const anzahl = parseInt(row.Anzahl, 10);
            return `${id}:${isFinite(anzahl) ? anzahl : 0}`;
        })
        .sort()
        .join(',');
}

// Was auf dem Knopf steht. Hat der Kunde selbst eine Pflanze aufgenommen,
// verspricht "neu generieren" das Falsche - der Entwurf wird um seine Auswahl
// herum neu gerechnet, nicht neu erfunden.
function neuentwurfLabel(alternative) {
    const stand = window.neuentwuerfe || { verbraucht: 0, grenze: 3 };
    if ((stand.grenze || 0) - (stand.verbraucht || 0) <= 0) {
        return CONFIG.NEUENTWURF_LABEL_AUS
            .replace('{verbraucht}', stand.verbraucht)
            .replace('{grenze}', stand.grenze);
    }
    const manuell = Array.isArray(alternative) &&
        alternative.some(r => r && r.source === 'manual');
    return manuell ? CONFIG.NEUENTWURF_LABEL_MANUELL : CONFIG.NEUENTWURF_LABEL;
}

function renderNeuentwurfLeiste(altIdx, alternative) {
    const stand = window.neuentwuerfe || { verbraucht: 0, grenze: 3 };
    const uebrig = Math.max(0, (stand.grenze || 0) - (stand.verbraucht || 0));
    const aufgebraucht = uebrig <= 0;
    const text = neuentwurfLabel(alternative);
    // Ausgangsstand am Element festhalten, damit spaetere Klicks dagegen
    // vergleichen koennen.
    const basis = mengenSchluessel(alternative);
    const titel = aufgebraucht ? '' : ` title="${escapeHtml(CONFIG.NEUENTWURF_HINWEIS)}"`;
    return `<div class="neuentwurf-leiste" data-alt-index="${altIdx}"
        data-basis="${escapeHtml(basis)}">
        <button type="button" class="btn-secondary btn-aktion btn-neuentwurf"
            disabled${titel} data-aktion="neuentwurf" data-alt-index="${altIdx}">${escapeHtml(text)}</button>
    </div>`;
}

// "24,90 €" -> 24.9 . Deutsche Schreibweise: Punkt ist Tausender, Komma ist
// Dezimaltrenner. Gibt null zurueck, wenn kein Preis dasteht ("-").
function preisAlsZahl(text) {
    if (text === null || text === undefined) return null;
    const roh = String(text).replace(/[^0-9,.-]/g, '').replace(/\./g, '').replace(',', '.');
    const zahl = parseFloat(roh);
    return isFinite(zahl) ? zahl : null;
}

function euro(zahl) {
    return zahl.toFixed(2).replace('.', ',') + ' €';
}

// Uebernimmt eine geaenderte Stueckzahl in die DATEN und rechnet Zeile und
// Summe neu.
//
// Vorher aenderte der Stepper nur das textContent der Anzeige. Der Warenkorb
// liest aber window.plantAlternatives, also die unveraenderte Serverliste -
// wer die Menge aenderte und ohne Neuentwurf auf "In den Warenkorb" klickte,
// bekam die ALTEN Mengen. Und die Summenzeile blieb ebenfalls stehen.
//
// Jetzt ist die Datenzeile die eine Quelle: Stepper schreibt hinein, Anzeige,
// Summe, Warenkorb und der "im Warenkorb"-Schluessel lesen daraus.
function uebernimmMenge(altIdx, zeilenNr, menge, akkordeon) {
    const liste = (window.plantAlternatives || [])[altIdx - 1];
    if (!Array.isArray(liste) || !liste[zeilenNr]) return;

    const zeile = liste[zeilenNr];
    zeile.Anzahl = menge;

    const einzel = preisAlsZahl(zeile.Einzelpreis);
    if (einzel !== null) zeile.Gesamt = euro(einzel * menge);

    // Summe ueber alle Positionen ausser der SUMME-Zeile selbst
    let summe = 0;
    let summenZeile = null;
    liste.forEach(r => {
        if (!r) return;
        if (r.Pflanze === 'SUMME') { summenZeile = r; return; }
        const e = preisAlsZahl(r.Einzelpreis);
        const a = parseInt(r.Anzahl, 10);
        if (e !== null && isFinite(a)) summe += e * a;
    });
    if (summenZeile) summenZeile.Gesamt = summe > 0 ? euro(summe) : '-';

    // Anzeige nachziehen, ohne die Tabelle neu zu bauen - ein Neuaufbau wuerde
    // den Fokus vom gerade gedrueckten Knopf nehmen.
    if (!akkordeon) return;
    const stepper = akkordeon.querySelector(
        `.mengen-stepper[data-alt-index="${altIdx}"][data-zeile="${zeilenNr}"]`);
    const zelle = stepper && stepper.closest('tr') &&
                  stepper.closest('tr').lastElementChild;
    if (zelle && einzel !== null) zelle.textContent = zeile.Gesamt;

    const summenFeld = akkordeon.querySelector('tr.sum-row td:last-child');
    if (summenFeld && summenZeile) summenFeld.textContent = summenZeile.Gesamt;
}

// Klicks auf Plus/Minus. Ereignisdelegation statt eines Zuhoerers je Knopf -
// die Tabelle wird beim Neuerzeugen komplett ersetzt, einzelne Zuhoerer
// blieben sonst an verwaisten Knoten haengen.
function verdrahteStepper(wurzel, altIdx) {
    const tabelle = wurzel.querySelector('.table-scroll-wrapper');
    if (!tabelle) return;
    tabelle.addEventListener('click', (e) => {
        // Waehrend ein Lauf offen ist, sind die Stueckzahlen eingefroren -
        // sie sind bereits abgeschickt. `inert` und pointer-events:none
        // sperren die Maus, aber nicht jeden Weg: ohne inert-Unterstuetzung
        // kann man den Knopf per Tab erreichen und mit Enter ausloesen, und
        // die angezeigte Liste passte dann nicht mehr zu der, die der Server
        // gerade zeichnet.
        if (activeRequest) return;
        const knopf = e.target.closest('.stepper-btn');
        if (!knopf) return;
        const stepper = knopf.closest('.mengen-stepper');
        if (!stepper) return;
        const feld = stepper.querySelector('.stepper-wert');
        const schritt = parseInt(knopf.dataset.schritt, 10) || 0;
        const jetzt = parseInt(feld.textContent, 10) || 0;
        // 0 heisst entfernen, 20 ist die serverseitige Obergrenze je Position.
        const neu = Math.max(0, Math.min(20, jetzt + schritt));
        if (neu === jetzt) return;
        feld.textContent = String(neu);
        stepper.classList.toggle('menge-null', neu === 0);
        uebernimmMenge(altIdx, parseInt(stepper.dataset.zeile, 10), neu, wurzel);
        pruefeAenderung(altIdx);
    });
}

// Gleicht die eingestellten Mengen gegen den Stand ab, MIT DEM der Entwurf
// erzeugt wurde, und schaltet den Knopf entsprechend frei oder wieder aus.
function pruefeAenderung(altIdx) {
    const leiste = document.querySelector(`.neuentwurf-leiste[data-alt-index="${altIdx}"]`);
    if (!leiste) return;
    const knopf = leiste.querySelector('.btn-neuentwurf');
    if (!knopf) return;

    const stand = window.neuentwuerfe || { verbraucht: 0, grenze: 3 };
    if ((stand.grenze || 0) - (stand.verbraucht || 0) <= 0) return;  // aufgebraucht

    const jetzt = leseMengen(altIdx)
        .map(e => `${e.variant_id}:${e.anzahl}`).sort().join(',');
    const geaendert = jetzt !== (leiste.dataset.basis || '');

    leiste.classList.toggle('geaendert', geaendert);
    knopf.disabled = !geaendert;
    // Der Text kann sich seit dem Zeichnen geaendert haben: eine selbst
    // gewaehlte Pflanze kommt erst nach dem Rendern der Leiste dazu.
    const wunschtext = neuentwurfLabel((window.plantAlternatives || [])[altIdx - 1]);
    if (knopf.textContent !== 'Wird erstellt...' && knopf.textContent !== wunschtext) {
        knopf.textContent = wunschtext;
    }
    if (geaendert) {
        knopf.removeAttribute('title');
    } else {
        knopf.setAttribute('title', CONFIG.NEUENTWURF_HINWEIS);
    }
}

// Liest die eingestellten Mengen aus dem DOM - die Anzeige IST der Zustand.
function leseMengen(altIdx) {
    const stepper = document.querySelectorAll(
        `.mengen-stepper[data-alt-index="${altIdx}"]`);
    return [...stepper].map(s => {
        const feld = s.querySelector('.stepper-wert');
        return {
            variant_id: feld ? feld.dataset.variantId : null,
            anzahl: parseInt(feld ? feld.textContent : '0', 10) || 0
        };
    }).filter(e => e.variant_id);
}

function renderPlantAccordion(alternative, title, description, altIdx, hinweise) {
    // Immer im aktiven Zustand rendern. Ob der Entwurf schon im Warenkorb liegt,
    // entscheidet syncCartButtons() nach dem Rendern anhand des echten
    // Warenkorbs - beim Rendern steht window.plantAlternatives noch gar nicht,
    // die Variant-IDs sind hier also nicht bekannt.
    const btnClass = 'btn-primary btn-aktion btn-add-to-cart';
    const btnText = 'In den Warenkorb';
    const btnDisabled = '';
    const btnDataAdded = '';

    const wrapper = document.createElement('details');
    wrapper.setAttribute('data-alt-index', altIdx);
    wrapper.setAttribute('open', '');  // Standardmäßig ausgeklappt

    // SECURITY: Escape title to prevent XSS
    const safeTitle = escapeHtml(title);

    const summary = document.createElement('summary');
    summary.innerHTML = `<span>${safeTitle}</span><span class="caret">▶</span>`;

    const body = document.createElement('div');
    body.className = 'accordion-body';

    let descriptionHtml = '';
    if (description && description.trim()) {
        const isHTML = /<[a-z][\s\S]*>/i.test(description);

        if (isHTML) {
            // SECURITY: Sanitize HTML content from AI to remove dangerous tags/attributes
            descriptionHtml = `<div class="design-description">${sanitizeHtml(description)}</div>`;
        } else {
            // For plain text: escape first, then apply markdown-like formatting
            const safeDescription = escapeHtml(description);
            let html = safeDescription
                .replace(/### (.+)/g, '<h4>$1</h4>')
                .split('\n\n')
                .filter(p => p.trim())
                .map(p => p.startsWith('<h4>') ? p : `<p>${p.trim()}</p>`)
                .join('');
            descriptionHtml = `<div class="design-description">${html}</div>`;
        }
    }

    // Der Hinweis steht UEBER der Tabelle: der Kunde sucht dort nach seiner
    // Wunschpflanze und soll nicht erst darunter erfahren, warum sie fehlt.
    // Reihenfolge: erst die Liste, dann die Auskunft dazu, dann die Handlung.
    // Der Hinweis stand bis zum 08.09.2026 zwischen Ueberschrift und Tabelle
    // und unterbrach den Blick auf das, wofuer der Kunde gekommen ist. Unter
    // der Liste steht er da, wo die Frage entsteht - "wo ist mein Feigenbaum?"
    body.innerHTML = `
        ${generatePlantTable(alternative, altIdx)}
        ${renderPflanzenhinweise(hinweise)}
        ${renderNeuentwurfLeiste(altIdx, alternative)}
        ${descriptionHtml}
        <button type="button" class="${btnClass}" ${btnDisabled} ${btnDataAdded} data-aktion="warenkorb" data-alt-index="${altIdx}">${btnText}</button>
    `;
    verdrahteStepper(body, altIdx);
    verdrahteSuche(body, altIdx);

    wrapper.appendChild(summary);
    wrapper.appendChild(body);

    return wrapper;
}

// ============================================================================
// KATALOGSUCHE IN DER PFLANZLISTE (Schritt 3)
// ----------------------------------------------------------------------------
// Die Suche ist keine eigene Box, sondern die vorletzte Zeile der Tabelle -
// direkt unter der letzten Pflanze, ueber der Summe. Dort entsteht der
// Gedanke "da fehlt noch etwas", und dort steht das Feld.
//
// Der Katalog kommt EINMAL je Sitzung als /api/catalog/search-index und wird
// im Browser durchsucht. Jeder Tastendruck an den Server zu schicken waere
// bei 312 Varianten Verschwendung - und offline unbrauchbar.
//
// KEIN localStorage in diesem Abschnitt: der Index wird bewusst nur im
// Arbeitsspeicher gehalten. Ein Katalog, der einen Reload ueberlebt, waere
// ein Katalog, der veraltete Preise und ausverkaufte Groessen anbietet.
// ============================================================================

let suchindexLauf = null;      // Promise, damit parallele Aufrufe eine Ladung teilen
let suchindexDaten = null;     // flache Liste, ein Eintrag je lieferbarer Variante
let suchWerk = null;           // Fuse-Instanz, null solange die Bibliothek fehlt

// Umlaute und Grossschreibung wegnehmen. Wer "Bluetenhartriegel" tippt, soll
// "Blütenhartriegel" finden - und umgekehrt.
function suchNormal(text) {
    return String(text == null ? '' : text)
        .toLowerCase()
        .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
        .replace(/\s+/g, ' ')
        .trim();
}

// Fuse.js vom CDN nachladen. Schlaegt das fehl, faellt die Suche auf einen
// einfachen Teilstring-Vergleich zurueck - schlechter, aber benutzbar. Der
// Fehlschlag wird protokolliert, nicht verschluckt.
function ladeFuse() {
    if (window.Fuse) return Promise.resolve(window.Fuse);
    return new Promise((erfuellen) => {
        const skript = document.createElement('script');
        skript.src = CONFIG.FUSE_CDN;
        skript.integrity = CONFIG.FUSE_SRI;
        skript.crossOrigin = 'anonymous';
        skript.async = true;
        skript.onload = () => erfuellen(window.Fuse || null);
        skript.onerror = () => {
            console.warn('Katalogsuche: Fuse.js konnte nicht geladen werden (' +
                         CONFIG.FUSE_CDN + '). Die Suche arbeitet mit einfachem ' +
                         'Textvergleich weiter.');
            erfuellen(null);
        };
        document.head.appendChild(skript);
    });
}

// Laedt den Index und baut das Suchwerk. Mehrfachaufrufe teilen sich denselben
// Lauf; ein Fehlschlag wird zurueckgesetzt, damit ein spaeterer Versuch nicht
// an einem alten abgelehnten Promise haengen bleibt.
function ladeSuchindex() {
    if (suchindexLauf) return suchindexLauf;

    suchindexLauf = (async () => {
        const antwort = await fetch(getApiBaseUrl() + '/api/catalog/search-index', {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        });
        if (!antwort.ok) {
            throw new Error('Katalog nicht abrufbar (HTTP ' + antwort.status + ')');
        }
        const daten = await antwort.json();
        suchindexDaten = Array.isArray(daten.artikel) ? daten.artikel : [];

        // Vorgerechnete Suchfelder: Fuse und der Rueckfall lesen beide daraus,
        // sonst wird bei jedem Tastendruck 312-mal neu normalisiert.
        suchindexDaten.forEach(e => {
            e._such = suchNormal([
                e.title, e.display_name, e.name_botanisch,
                (e.common_names || []).join(' ')
            ].filter(Boolean).join(' '));
        });

        const Fuse = await ladeFuse();
        if (Fuse) {
            suchWerk = new Fuse(suchindexDaten, {
                keys: [
                    { name: 'name_botanisch', weight: 0.40 },
                    { name: 'common_names',   weight: 0.40 },
                    { name: 'title',          weight: 0.15 },
                    { name: 'tags',           weight: 0.05 }
                ],
                threshold: CONFIG.SUCHE_SCHWELLE,
                ignoreLocation: true,     // der Name steht selten am Anfang des Titels
                minMatchCharLength: 2,
                includeScore: true
            });
        }
        console.log('Katalogsuche bereit: ' + suchindexDaten.length + ' Varianten' +
                    (suchWerk ? ' (Fuse.js)' : ' (Textvergleich)'));
        return suchindexDaten;
    })();

    suchindexLauf.catch((fehler) => {
        console.error('Katalogsuche: Index konnte nicht geladen werden.', fehler);
        suchindexLauf = null;   // naechster Tastendruck darf es erneut versuchen
    });

    return suchindexLauf;
}

// Rueckfall ohne Fuse: Treffer nach Position des Suchbegriffs im Namen.
function trefferOhneFuse(begriff) {
    const n = suchNormal(begriff);
    const treffer = [];
    (suchindexDaten || []).forEach(e => {
        const pos = e._such.indexOf(n);
        if (pos >= 0) treffer.push({ item: e, score: pos === 0 ? 0 : 0.2 });
    });
    return treffer.sort((a, b) => a.score - b.score);
}

// Gibt {liste, woertlich} zurueck. `woertlich` sagt, ob der Suchbegriff so,
// wie er getippt wurde, in einem Namen, im botanischen Namen oder in einem
// Synonym vorkommt.
//
// Die Unterscheidung traegt zwei Entscheidungen:
//   * Gibt es woertliche Treffer, werden NUR die gezeigt. Fuse ist mit
//     Absicht fehlertolerant, und das kostet: auf "feige" kamen hinter der
//     Feige vier Weigelien.
//   * Gibt es keine, ist alles Uebrige geraten. Dann werden die Vermutungen
//     als solche ueberschrieben und der Katalog wird gefragt (Schritt 4).
function sucheTreffer(begriff) {
    if (!suchindexDaten || begriff.length < CONFIG.SUCHE_MIN_ZEICHEN) {
        return { liste: [], woertlich: false };
    }
    const roh = suchWerk ? suchWerk.search(begriff) : trefferOhneFuse(begriff);
    const gesucht = suchNormal(begriff);
    const woertlich = roh.filter(t => t.item._such && t.item._such.includes(gesucht));
    const genommen = woertlich.length ? woertlich : roh;

    return {
        liste: genommen.slice(0, CONFIG.SUCHE_MAX_TREFFER).map(t => t.item),
        woertlich: woertlich.length > 0
    };
}

// Verfuegbarkeit in Worten. Alle Eintraege im Index sind lieferbar - die Zahl
// sagt nur dann etwas, wenn sie knapp ist.
function bestandText(eintrag) {
    const n = parseInt(eintrag.lagerbestand, 10);
    if (isFinite(n) && n > 0 && n <= 5) return 'nur noch ' + n;
    return 'lieferbar';
}

// Baut die Trefferliste. Gruppiert nach handle: der Produktname steht einmal,
// die Groessen darunter. Hat ein Produkt nur eine lieferbare Groesse, entfaellt
// die Gruppe und der Treffer ist direkt anklickbar.
function baueVorschlaege(treffer) {
    const gruppen = [];
    const nachHandle = {};
    treffer.forEach(e => {
        if (!nachHandle[e.handle]) {
            nachHandle[e.handle] = { handle: e.handle, kopf: e, varianten: [] };
            gruppen.push(nachHandle[e.handle]);
        }
        nachHandle[e.handle].varianten.push(e);
    });

    let lfd = 0;
    let html = '';
    gruppen.forEach(g => {
        const bild = sanitizeUrl(g.kopf.image_url);
        const bildHtml = bild
            ? `<img class="such-bild" src="${bild}" alt="" loading="lazy">`
            : `<span class="such-bild such-bild-leer" aria-hidden="true"></span>`;
        const name = escapeHtml(g.kopf.display_name || g.kopf.title || '');
        const botanik = g.kopf.name_botanisch
            ? `<span class="such-botanik">${escapeHtml(g.kopf.name_botanisch)}</span>`
            : '';

        if (g.varianten.length === 1) {
            const v = g.varianten[0];
            html += `<li class="such-eintrag" role="presentation">` +
                `<button type="button" class="such-treffer" role="option" aria-selected="false"` +
                ` data-lfd="${lfd++}" data-variant-id="${escapeHtml(String(v.variant_id))}">` +
                bildHtml +
                `<span class="such-text"><span class="such-name">${name}</span>${botanik}` +
                (v.variant_title ? `<span class="such-groesse">${escapeHtml(v.variant_title)}</span>` : '') +
                `</span>` +
                `<span class="such-rechts"><span class="such-preis">${escapeHtml(euro(v.preis))}</span>` +
                `<span class="such-lager">${escapeHtml(bestandText(v))}</span></span>` +
                `</button></li>`;
            return;
        }

        html += `<li class="such-gruppe" role="presentation">` +
            `<div class="such-kopf">${bildHtml}` +
            `<span class="such-text"><span class="such-name">${name}</span>${botanik}</span></div>`;
        g.varianten.forEach(v => {
            html += `<button type="button" class="such-treffer such-treffer-variante" role="option"` +
                ` aria-selected="false" data-lfd="${lfd++}"` +
                ` data-variant-id="${escapeHtml(String(v.variant_id))}">` +
                `<span class="such-groesse">${escapeHtml(v.variant_title || 'Standardgröße')}</span>` +
                `<span class="such-rechts"><span class="such-preis">${escapeHtml(euro(v.preis))}</span>` +
                `<span class="such-lager">${escapeHtml(bestandText(v))}</span></span>` +
                `</button>`;
        });
        html += `</li>`;
    });
    return html;
}

// Offener Rueckfall-Auftrag je Entwurf: {zeit, frage}. Damit laesst sich eine
// Antwort verwerfen, die zu einem Begriff gehoert, der nicht mehr im Feld
// steht - sonst springt die Liste dem Kunden unter den Fingern weg.
const rueckfallLauf = {};

// Fragt den Server, wenn die Suche im Browser nichts gefunden hat. Gibt die
// Eintraege zu den gelieferten Handles zurueck - aufgeloest aus dem Index, den
// der Browser ohnehin hat.
async function rueckfallTreffer(begriff) {
    const antwort = await fetch(getApiBaseUrl() + '/api/catalog/semantic-search', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: begriff })
    });
    if (!antwort.ok) {
        const daten = await antwort.json().catch(() => ({}));
        const fehler = new Error(daten.error || ('HTTP ' + antwort.status));
        fehler.status = antwort.status;
        throw fehler;
    }
    const daten = await antwort.json();
    const handles = Array.isArray(daten.handles) ? daten.handles : [];
    // Reihenfolge der Handles ist die Rangfolge des Modells; alle Groessen
    // eines Handles kommen mit, damit die Liste aussieht wie sonst auch.
    const treffer = [];
    handles.forEach(h => {
        (suchindexDaten || []).forEach(e => { if (e.handle === h) treffer.push(e); });
    });
    return treffer.slice(0, CONFIG.SUCHE_MAX_TREFFER);
}

function suchPanel(altIdx) {
    return document.querySelector(`.such-panel[data-alt-index="${altIdx}"]`);
}

function schliesseVorschlaege(altIdx) {
    if (rueckfallLauf[altIdx]) {
        clearTimeout(rueckfallLauf[altIdx].zeit);
        delete rueckfallLauf[altIdx];
    }
    const panel = suchPanel(altIdx);
    if (!panel) return;
    const liste = panel.querySelector('.such-liste');
    if (liste) { liste.innerHTML = ''; liste.hidden = true; }
    panel.dataset.markierung = '-1';
    const feld = document.querySelector(`.such-feld[data-alt-index="${altIdx}"]`);
    if (feld) {
        feld.setAttribute('aria-expanded', 'false');
        feld.removeAttribute('aria-activedescendant');
    }
}

function markiereTreffer(altIdx, richtung) {
    const panel = suchPanel(altIdx);
    if (!panel) return;
    const knoepfe = [...panel.querySelectorAll('.such-treffer')];
    if (!knoepfe.length) return;
    let pos = parseInt(panel.dataset.markierung, 10);
    if (!isFinite(pos)) pos = -1;
    pos += richtung;
    if (pos < 0) pos = knoepfe.length - 1;
    if (pos >= knoepfe.length) pos = 0;
    panel.dataset.markierung = String(pos);
    knoepfe.forEach((k, i) => {
        const aktiv = i === pos;
        k.classList.toggle('ist-aktiv', aktiv);
        k.setAttribute('aria-selected', aktiv ? 'true' : 'false');
        if (aktiv) k.scrollIntoView({ block: 'nearest' });
    });
}

function gewaehlterTreffer(altIdx) {
    const panel = suchPanel(altIdx);
    if (!panel) return null;
    const pos = parseInt(panel.dataset.markierung, 10);
    const knoepfe = [...panel.querySelectorAll('.such-treffer')];
    if (isFinite(pos) && pos >= 0 && knoepfe[pos]) return knoepfe[pos];
    // Ohne Pfeiltaste zaehlt der erste Treffer - Enter soll nicht ins Leere gehen.
    return knoepfe[0] || null;
}

async function zeigeVorschlaege(altIdx, begriff) {
    const panel = suchPanel(altIdx);
    if (!panel) return;
    const liste = panel.querySelector('.such-liste');
    const feld = document.querySelector(`.such-feld[data-alt-index="${altIdx}"]`);
    if (!liste) return;

    if (begriff.length < CONFIG.SUCHE_MIN_ZEICHEN) {
        schliesseVorschlaege(altIdx);
        return;
    }

    if (!suchindexDaten) {
        liste.innerHTML = `<li class="such-hinweis">Katalog wird geladen…</li>`;
        liste.hidden = false;
        try {
            await ladeSuchindex();
        } catch (fehler) {
            liste.innerHTML = `<li class="such-hinweis">Der Katalog ist gerade nicht durchsuchbar.</li>`;
            return;
        }
        // Waehrend des Ladens kann der Kunde weitergetippt haben.
        if (!feld || feld.value.trim() !== begriff) return;
    }

    const { liste: treffer, woertlich } = sucheTreffer(begriff);

    liste.hidden = false;
    panel.dataset.markierung = '-1';
    if (feld) feld.setAttribute('aria-expanded', 'true');

    if (woertlich) {
        // Echte Treffer. Kein Serveraufruf - dafuer gibt es keinen Anlass.
        if (rueckfallLauf[altIdx]) {
            clearTimeout(rueckfallLauf[altIdx].zeit);
            delete rueckfallLauf[altIdx];
        }
        liste.innerHTML = baueVorschlaege(treffer);
        return;
    }

    // Ab hier ist alles geraten. Die Vermutungen bleiben trotzdem sofort
    // stehen - eine leere Liste waere die einzige Antwort, die niemandem
    // hilft - aber sie stehen unter einem Vorbehalt, und der Katalog wird
    // gefragt. Erst nach der Wartezeit: waehrend des Tippens ist der Begriff
    // ohnehin noch halbfertig.
    liste.innerHTML = treffer.length
        ? `<li class="such-hinweis such-hinweis-rueckfall">${escapeHtml(CONFIG.SUCHE_RUECKFALL_TEXT)}</li>`
          + baueVorschlaege(treffer)
        : `<li class="such-hinweis">${escapeHtml(CONFIG.SUCHE_RUECKFALL_TEXT)}</li>`;

    if (rueckfallLauf[altIdx]) clearTimeout(rueckfallLauf[altIdx].zeit);
    rueckfallLauf[altIdx] = {
        frage: begriff,
        zeit: setTimeout(() => starteRueckfall(altIdx, begriff), CONFIG.SUCHE_RUECKFALL_MS)
    };
}

async function starteRueckfall(altIdx, begriff) {
    const feld = document.querySelector(`.such-feld[data-alt-index="${altIdx}"]`);
    // Zwischen Tastendruck und Ablauf der Wartezeit kann sich alles geaendert
    // haben - dann gehoert die Antwort nicht mehr zu dem, was dasteht.
    if (!feld || feld.value.trim() !== begriff) return;

    let treffer = [];
    try {
        treffer = await rueckfallTreffer(begriff);
    } catch (fehler) {
        console.warn('Katalogsuche: Rueckfall fehlgeschlagen.', fehler);
        ersetzeKopfzeile(altIdx, feld, begriff, fehler.status === 429
            ? 'Zu viele Suchanfragen. Bitte kurz warten.'
            : 'Nichts Genaues gefunden.');
        return;
    }

    if (feld.value.trim() !== begriff) return;
    const panelJetzt = suchPanel(altIdx);
    const listeJetzt = panelJetzt && panelJetzt.querySelector('.such-liste');
    if (!listeJetzt) return;

    if (!treffer.length) {
        // Der Katalog weiss auch nichts. Was schon dasteht, bleibt stehen -
        // es war die bessere Vermutung als gar nichts; nur die Kopfzeile sagt
        // jetzt die Wahrheit.
        ersetzeKopfzeile(altIdx, feld, begriff, 'Nichts Genaues gefunden.');
        return;
    }

    // Der Katalog hat etwas gefunden. Es ersetzt die Vermutungen, bleibt aber
    // als Vermutung gekennzeichnet - der Kunde hat schliesslich etwas anderes
    // getippt, als in der Liste steht.
    listeJetzt.innerHTML =
        `<li class="such-hinweis such-hinweis-rueckfall">Meintest du …?</li>` +
        baueVorschlaege(treffer);
    panelJetzt.dataset.markierung = '-1';
}

// Tauscht nur die Kopfzeile der Trefferliste aus und laesst die Treffer
// stehen. Gibt es keine, bleibt der Hinweis allein zurueck.
function ersetzeKopfzeile(altIdx, feld, begriff, text) {
    if (!feld || feld.value.trim() !== begriff) return;
    const panel = suchPanel(altIdx);
    const liste = panel && panel.querySelector('.such-liste');
    if (!liste) return;
    const kopf = liste.querySelector('.such-hinweis');
    if (kopf) {
        kopf.textContent = text;
    } else {
        liste.innerHTML = `<li class="such-hinweis">${escapeHtml(text)}</li>` + liste.innerHTML;
    }
}

// Baut die Tabelle des Entwurfs neu. Wird nach dem Einfuegen einer Zeile
// gebraucht: uebernimmMenge() flickt nur bestehende Zellen, eine neue Zeile
// kann es nicht erzeugen.
//
// Nach dem Neuaufbau muessen die Zuhoerer wieder dran - der alte
// .table-scroll-wrapper ist weg, und mit ihm die Ereignisdelegation.
function baueTabelleNeu(altIdx, fokusInsSuchfeld) {
    const akkordeon = document.querySelector(
        `#plantAccordions details[data-alt-index="${altIdx}"]`);
    if (!akkordeon) return;
    const koerper = akkordeon.querySelector('.accordion-body');
    const alt = koerper && koerper.querySelector('.table-scroll-wrapper');
    const liste = (window.plantAlternatives || [])[altIdx - 1];
    if (!koerper || !alt || !Array.isArray(liste)) return;

    const huelle = document.createElement('div');
    huelle.innerHTML = generatePlantTable(liste, altIdx);
    const neu = huelle.firstElementChild;
    if (!neu) return;
    alt.replaceWith(neu);

    verdrahteStepper(koerper, altIdx);
    verdrahteSuche(koerper, altIdx);
    pruefeAenderung(altIdx);

    if (fokusInsSuchfeld) {
        const feld = koerper.querySelector(`.such-feld[data-alt-index="${altIdx}"]`);
        if (feld) { feld.value = ''; feld.focus(); }
    }
}

// Nimmt eine gewaehlte Variante in die Stueckliste auf.
//
// Die Zeile hat exakt denselben Bau wie eine Zeile vom Server, plus
// source:'manual'. generatePlantTable() liest die Felder einzeln und
// uebernimmMenge() rechnet ueber Einzelpreis und Anzahl - das zusaetzliche
// Feld faellt beiden nicht auf. Es reist nur mit, damit die Zeile als
// "von dir gewaehlt" erkennbar bleibt und ein spaeterer Schritt sie im
// Request unterscheiden kann.
function fuegePflanzeEin(altIdx, eintrag) {
    const liste = (window.plantAlternatives || [])[altIdx - 1];
    if (!Array.isArray(liste) || !eintrag) return;

    const id = String(eintrag.variant_id).replace(/\.0$/, '').trim();
    const vorhanden = liste.findIndex(
        r => r && r.Pflanze !== 'SUMME' && r.variant_id != null &&
             String(r.variant_id).replace(/\.0$/, '').trim() === id);

    if (vorhanden >= 0) {
        // Dieselbe Variante zweimal ist keine zweite Position, sondern ein
        // Stueck mehr. Zwei Zeilen mit derselben variant_id wuerde der Server
        // beim Neuentwurf ohnehin als 'doppelte_position' abweisen.
        const jetzt = parseInt(liste[vorhanden].Anzahl, 10) || 0;
        if (jetzt >= 20) {
            toast('Mehr als 20 Stück je Pflanze gehen nicht.', CONFIG.COLORS.error);
            return;
        }
        uebernimmMenge(altIdx, vorhanden, jetzt + 1, null);
        baueTabelleNeu(altIdx, true);
        toast(`${eintrag.display_name || eintrag.title}: jetzt ${jetzt + 1} Stück`,
              CONFIG.COLORS.success);
        return;
    }

    if (liste.filter(r => r && r.Pflanze !== 'SUMME').length >= 30) {
        toast('Mehr als 30 Positionen gehen nicht.', CONFIG.COLORS.error);
        return;
    }

    const preis = parseFloat(eintrag.preis);
    const zeile = {
        Pflanze: eintrag.title,                                   // Name fuer das Backend
        display_name: eintrag.display_name || eintrag.title,      // Name fuer den Kunden
        Anzahl: 1,
        Einzelpreis: isFinite(preis) ? euro(preis) : '-',
        Gesamt: isFinite(preis) ? euro(preis) : '-',
        variant_id: eintrag.variant_id,
        product_url: eintrag.product_url || null,
        source: 'manual'
    };

    const summenPos = liste.findIndex(r => r && r.Pflanze === 'SUMME');
    const einfuegePos = summenPos >= 0 ? summenPos : liste.length;
    liste.splice(einfuegePos, 0, zeile);

    // Summe ueber dieselbe Rechnung wie der Stepper - eine Quelle, nicht zwei.
    uebernimmMenge(altIdx, einfuegePos, 1, null);
    baueTabelleNeu(altIdx, true);
    toast(`${zeile.display_name} hinzugefügt`, CONFIG.COLORS.success);
}

// Haengt Suchfeld und Trefferliste an. Wird nach jedem Neuaufbau der Tabelle
// erneut aufgerufen, weil das Feld mit der Tabelle ersetzt wird.
function verdrahteSuche(wurzel, altIdx) {
    const feld = wurzel.querySelector(`.such-feld[data-alt-index="${altIdx}"]`);
    if (!feld) return;

    const wrapper = wurzel.querySelector('.table-scroll-wrapper');
    let panel = wurzel.querySelector(`.such-panel[data-alt-index="${altIdx}"]`);
    if (!panel) {
        // Die Liste steht BEWUSST ausserhalb von .table-scroll-wrapper: der
        // Wrapper hat overflow-x:auto und wuerde alles abschneiden, was unten
        // aus der Tabelle herausragt. Sie haengt stattdessen als eigene,
        // hoehenlose Schicht direkt darunter.
        panel = document.createElement('div');
        panel.className = 'such-panel';
        panel.dataset.altIndex = String(altIdx);
        panel.dataset.markierung = '-1';
        panel.innerHTML = `<ul class="such-liste" id="gp-such-liste-${altIdx}" role="listbox" hidden></ul>`;
        if (wrapper && wrapper.parentNode) {
            wrapper.parentNode.insertBefore(panel, wrapper.nextSibling);
        } else {
            wurzel.appendChild(panel);
        }
    }

    // Der Katalog wird geholt, sobald die Liste vor dem Kunden steht - nicht
    // erst beim ersten Tastendruck, sonst wartet er beim Tippen.
    ladeSuchindex().catch(() => { /* schon in ladeSuchindex protokolliert */ });

    feld.addEventListener('input', () => {
        if (activeRequest) return;
        zeigeVorschlaege(altIdx, feld.value.trim());
    });

    feld.addEventListener('keydown', (e) => {
        if (activeRequest) return;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            markiereTreffer(altIdx, e.key === 'ArrowDown' ? 1 : -1);
            return;
        }
        if (e.key === 'Escape') {
            schliesseVorschlaege(altIdx);
            return;
        }
        if (e.key === 'Enter') {
            e.preventDefault();
            const knopf = gewaehlterTreffer(altIdx);
            if (knopf) knopf.click();
        }
    });

    // Ereignisdelegation auf dem Panel: die Treffer entstehen und vergehen
    // mit jedem Tastendruck.
    if (panel.dataset.verdrahtet !== 'ja') {
        panel.dataset.verdrahtet = 'ja';
        panel.addEventListener('mousedown', (e) => {
            // Vor blur zugreifen, sonst schliesst der Fokusverlust die Liste,
            // bevor der Klick ankommt.
            if (e.target.closest('.such-treffer')) e.preventDefault();
        });
        panel.addEventListener('click', (e) => {
            if (activeRequest) return;
            const knopf = e.target.closest('.such-treffer');
            if (!knopf) return;
            const id = knopf.dataset.variantId;
            const eintrag = (suchindexDaten || []).find(
                x => String(x.variant_id) === id);
            if (!eintrag) {
                console.error('Katalogsuche: Variante ' + id + ' nicht im Index.');
                return;
            }
            schliesseVorschlaege(altIdx);
            fuegePflanzeEin(altIdx, eintrag);
        });
    }

    feld.addEventListener('blur', () => {
        // Kurz warten: ein Klick auf einen Treffer loest zuerst blur aus.
        setTimeout(() => {
            const panelJetzt = suchPanel(altIdx);
            if (panelJetzt && panelJetzt.contains(document.activeElement)) return;
            schliesseVorschlaege(altIdx);
        }, 120);
    });
}

// Klick irgendwo sonst schliesst offene Trefferlisten.
document.addEventListener('click', (e) => {
    if (e.target.closest('.such-panel') || e.target.closest('.such-feld')) return;
    document.querySelectorAll('.such-panel[data-alt-index]').forEach(p => {
        schliesseVorschlaege(parseInt(p.dataset.altIndex, 10));
    });
});

// ============================================================================
// VORHER-NACHHER-VERGLEICH
// ----------------------------------------------------------------------------
// Der Kunde zieht einen Griff ueber das Entwurfsbild und sieht darunter sein
// eigenes Foto. Damit das ueberhaupt etwas taugt, muessen beide denselben
// Ausschnitt zeigen - das rechnet der Server aus (services/bildausrichtung.py)
// und liefert ein Zuschnittrechteck plus die Angabe, ob er sich sicher ist.
//
// IST ER ES NICHT, PASSIERT HIER NICHTS. Dann bleibt es bei der gewohnten
// Einzelansicht. Ein fehlender Vergleich kostet nichts; ein daneben sitzender
// kostet Vertrauen in den ganzen Entwurf.
//
// Bedienung bewusst OHNE Gestenunterscheidung: Ziehen ueberall am Bild ist
// immer der Vergleich, der Zoom haengt an einem eigenen Knopf. Ein
// Bewegungs-Schwellwert fuer "Tippen oder Ziehen?" ist genau die Sorte Code,
// die auf einem Geraet funktioniert und auf dem naechsten nicht.
// ============================================================================

// Das verkleinerte Originalfoto der laufenden Sitzung. Bewusst getrennt von
// _lastImageDataUri: das wird nach dem Lauf mit dem ERZEUGTEN Bild
// ueberschrieben, das Foto waere danach weg.
let _originalFoto = null;
// Zugeschnittene Fassungen je Entwurf, damit der Zuschnitt nicht bei jedem
// Neuzeichnen erneut durch die Leinwand muss.
const _fotoZuschnitte = {};

// Verkleinert das hochgeladene Foto auf eine Kantenlaenge, die als
// Vergleichsbild reicht. Voll aufgeloest waeren es je nach Telefon mehrere
// Megabyte - der localStorage fasst rund fuenf.
//
// createImageBitmap mit imageOrientation:'from-image' richtet hochkant
// aufgenommene Fotos auf. Ohne das landet ein liegendes Bild unter einem
// stehenden Entwurf; dieselbe Falle wie serverseitig, siehe bildausrichtung.py.
// 900 px reichen: die Bildkarte ist selbst auf einem breiten Bildschirm keine
// 900 px breit, und in der Vergroesserung steht ohnehin der Entwurf im
// Vordergrund. 1200 px kosteten bei einem 1500-px-Foto noch 425 KB im
// Speicher - zu viel neben dem doppelt abgelegten Entwurfsbild.
async function verkleinereFoto(datei, maxKante = 900) {
    let quelle = null;
    try {
        if (typeof createImageBitmap === 'function') {
            quelle = await createImageBitmap(datei, { imageOrientation: 'from-image' });
        }
    } catch (fehler) {
        console.warn('Vergleich: createImageBitmap nicht nutzbar, weiche aus.', fehler);
    }
    if (!quelle) {
        quelle = await new Promise((erfuellen, ablehnen) => {
            const bild = new Image();
            bild.onload = () => erfuellen(bild);
            bild.onerror = ablehnen;
            bild.src = URL.createObjectURL(datei);
        });
    }
    const breite = quelle.width || quelle.naturalWidth;
    const hoehe = quelle.height || quelle.naturalHeight;
    if (!breite || !hoehe) return null;

    const faktor = Math.min(1, maxKante / Math.max(breite, hoehe));
    const leinwand = document.createElement('canvas');
    leinwand.width = Math.round(breite * faktor);
    leinwand.height = Math.round(hoehe * faktor);
    leinwand.getContext('2d').drawImage(quelle, 0, 0, leinwand.width, leinwand.height);
    if (quelle.close) quelle.close();
    return leinwand.toDataURL('image/jpeg', 0.75);
}

// Schneidet das Foto auf den vom Server bestimmten Ausschnitt. Danach haben
// Foto und Entwurf dasselbe Seitenverhaeltnis und koennen mit identischem CSS
// uebereinandergelegt werden - ohne das laufen sie im 4:3-Rahmen der Karte
// auseinander, obwohl der Inhalt ausgerichtet ist.
function schneideFoto(fotoDataUri, box) {
    const schluessel = (box || []).join(',');
    if (_fotoZuschnitte[schluessel]) return Promise.resolve(_fotoZuschnitte[schluessel]);
    return new Promise((erfuellen) => {
        const bild = new Image();
        bild.onload = () => {
            try {
                const b = bild.naturalWidth, h = bild.naturalHeight;
                const x0 = Math.round((box[0] || 0) * b);
                const y0 = Math.round((box[1] || 0) * h);
                const x1 = Math.round((box[2] || 1) * b);
                const y1 = Math.round((box[3] || 1) * h);
                const leinwand = document.createElement('canvas');
                leinwand.width = Math.max(1, x1 - x0);
                leinwand.height = Math.max(1, y1 - y0);
                leinwand.getContext('2d').drawImage(
                    bild, x0, y0, leinwand.width, leinwand.height,
                    0, 0, leinwand.width, leinwand.height);
                const fertig = leinwand.toDataURL('image/jpeg', 0.85);
                _fotoZuschnitte[schluessel] = fertig;
                erfuellen(fertig);
            } catch (fehler) {
                console.warn('Vergleich: Zuschnitt fehlgeschlagen.', fehler);
                erfuellen(null);
            }
        };
        bild.onerror = () => {
            console.warn('Vergleich: Foto nicht ladbar.');
            erfuellen(null);
        };
        bild.src = fotoDataUri;
    });
}

// Gibt es fuer diesen Entwurf einen belastbaren Vergleich?
function vergleichFuer(altIdx) {
    const v = (window.gpVergleiche || [])[altIdx - 1];
    if (!v || !v.sicher || !Array.isArray(v.box)) return null;
    if (!_originalFoto) return null;
    return v;
}

// Haengt den Schieber an eine bereits gezeichnete Bildkarte. Getrennt vom
// Zeichnen, weil der Zuschnitt asynchron ist - die Karte steht sofort, der
// Vergleich kommt Sekundenbruchteile spaeter dazu.
async function ruesteVergleichNach(karte, altIdx) {
    const v = vergleichFuer(altIdx);
    if (!karte || !v) return;
    const buehne = karte.querySelector('.bild-buehne');
    if (!buehne || buehne.querySelector('.vorher-bild')) return;

    const zuschnitt = await schneideFoto(_originalFoto, v.box);
    if (!zuschnitt) return;

    const vorher = document.createElement('img');
    vorher.className = 'vorher-bild';
    vorher.alt = 'Dein Garten vorher';
    vorher.src = zuschnitt;
    // Entscheidung: der ENTWURF ist zu sehen, der Griff steht links.
    buehne.style.setProperty('--vergleich-pos', '0%');
    buehne.appendChild(vorher);

    const griff = document.createElement('div');
    griff.className = 'vergleich-griff';
    griff.setAttribute('role', 'slider');
    griff.setAttribute('aria-label', 'Vergleich zwischen Foto und Entwurf');
    griff.setAttribute('aria-valuemin', '0');
    griff.setAttribute('aria-valuemax', '100');
    griff.setAttribute('aria-valuenow', '0');
    griff.tabIndex = 0;
    griff.innerHTML = '<span class="griff-knopf" aria-hidden="true">‹ ›</span>';
    buehne.appendChild(griff);

    const marken = document.createElement('div');
    marken.className = 'vergleich-marken';
    // Mit Vergleich uebernimmt die Marke "Nachher" die Wuchszeit, und
    // .gp-wuchsmarke oben links wird per CSS ausgeblendet. Grund: sobald der
    // Kunde den Griff aufzieht, zeigt die LINKE Bildhaelfte das Foto - eine
    // Marke oben links wuerde dann das Foto mit "in 3-5 Jahren" beschriften.
    // "Nachher" steht rechts und damit immer ueber dem Entwurf.
    marken.innerHTML = '<span class="marke marke-vorher">Vorher</span>' +
                       '<span class="marke marke-nachher">Nachher \u00b7 in 3\u20135 Jahren</span>';
    buehne.appendChild(marken);

    buehne.classList.add('hat-vergleich');
    verdrahteVergleich(buehne, griff);
}

function verdrahteVergleich(buehne, griff) {
    let zieht = false;

    const setze = (anteil) => {
        const wert = Math.max(0, Math.min(100, anteil));
        buehne.style.setProperty('--vergleich-pos', wert + '%');
        griff.setAttribute('aria-valuenow', String(Math.round(wert)));
        // Die Marken verblassen, sobald der Kunde zieht - sie erklaeren nur
        // den Anfangszustand.
        buehne.classList.toggle('in-bewegung', wert > 2 && wert < 98);
    };

    const ausEreignis = (e) => {
        const rahmen = buehne.getBoundingClientRect();
        const x = (e.touches ? e.touches[0].clientX : e.clientX) - rahmen.left;
        return (x / Math.max(1, rahmen.width)) * 100;
    };

    const beginn = (e) => {
        if (activeRequest) return;
        zieht = true;
        buehne.classList.add('zieht');
        setze(ausEreignis(e));
        e.preventDefault();
    };
    const bewegung = (e) => {
        if (!zieht) return;
        setze(ausEreignis(e));
        e.preventDefault();
    };
    const ende = () => {
        zieht = false;
        buehne.classList.remove('zieht');
    };

    buehne.addEventListener('mousedown', beginn);
    window.addEventListener('mousemove', bewegung);
    window.addEventListener('mouseup', ende);
    buehne.addEventListener('touchstart', beginn, { passive: false });
    buehne.addEventListener('touchmove', bewegung, { passive: false });
    buehne.addEventListener('touchend', ende);

    // Mit der Tastatur bedienbar - der Griff ist ein echtes Bedienelement,
    // kein Bild mit Zuhoerer.
    griff.addEventListener('keydown', (e) => {
        const jetzt = parseFloat(griff.getAttribute('aria-valuenow')) || 0;
        if (e.key === 'ArrowLeft') { setze(jetzt - 5); e.preventDefault(); }
        else if (e.key === 'ArrowRight') { setze(jetzt + 5); e.preventDefault(); }
        else if (e.key === 'Home') { setze(0); e.preventDefault(); }
        else if (e.key === 'End') { setze(100); e.preventDefault(); }
    });
}

function saveToStorage(data, images, alternatives, titles, descriptions, hinweise) {
    try {
        // Nur speichern wenn mindestens Pflanzlisten vorhanden sind
        if (alternatives.length === 0) {
            console.log('Keine Pflanzlisten vorhanden, überspringe Speicherung');
            return;
        }

        const storageData = {
            // C-10: die Serverantwort (mit dem Bild als zweiter Kopie) lag hier
            // bis 09.09.2026 komplett mit drin und wurde nie zurueckgelesen.
            images: images, // Kann leer sein wenn Bildgenerierung fehlschlug
            alternatives: alternatives,
            titles: titles,
            descriptions: descriptions,
            // A3: je Entwurf die Hinweise. Ohne sie verschwaende ein Reload
            // genau die Auskunft, warum die Wunschpflanze fehlt.
            hinweise: hinweise || [],
            // E-18: das Foto steht NICHT hier. localStorage ist origin-weit
            // und 30 Minuten lang fuer jedes Theme-, App- und Tracking-Skript
            // des Shops lesbar. Es liegt im sessionStorage (sichereFoto).
            vergleiche: window.gpVergleiche || [],
            // B-03: Hinweis des Servers, wenn die Liste ohne Bild kam.
            bildHinweis: (data && data.status === 'partial' && data.hinweis) ? String(data.hinweis) : null,
            neuentwuerfe: window.neuentwuerfe || { verbraucht: 0, grenze: 3 },
            // B: ohne die Sitzungs-ID waere der Neuentwurf-Knopf nach einem
            // Reload tot - der Server weiss dann nicht, welchen Entwurf er
            // fortschreiben soll.
            sessionId: window.gpSessionId || null,
            timestamp: Date.now(),
            expiresAt: Date.now() + CONFIG.CACHE_DURATION_MS,
            // Markiere ob Bilder erfolgreich generiert wurden
            imageGenerationSuccess: images.length > 0
        };
        schreibeSpeicher(storageData);
        sichereFoto(storageData.expiresAt);
        planeAblauf(storageData.expiresAt);
        if (images[0]) _lastImageDataUri = images[0];
        console.log(`Session gespeichert: ${images.length} Bilder, ${alternatives.length} Pflanzlisten`);
    } catch (e) {
        console.error('Storage error:', e);
    }
}

// Schreibt den Stand weg und opfert im Notfall den Vergleich, nicht den Entwurf.
//
// Der Speicher fasst je nach Browser rund fuenf Megabyte. Darin liegen das
// erzeugte Bild (zweimal - einmal in `data`, einmal in `images`) und seit dem
// Vorher-Nachher-Vergleich zusaetzlich das Foto. Ein grosses Foto auf einem
// Geraet mit knappem Kontingent bringt setItem zum Werfen, und vorher wurde
// dann GAR NICHTS gespeichert: nach dem naechsten Neuladen war der Entwurf weg.
//
// Der Entwurf ist das, wofuer der Kunde gewartet hat. Der Vergleich ist eine
// Zugabe. Also fliegt zuerst das Foto raus, dann die Ausrichtung; erst wenn
// auch das nicht reicht, ist wirklich nichts zu machen.
function schreibeSpeicher(stand) {
    // E-18: ein Foto hat hier nichts verloren, egal woher der Stand kommt.
    if (stand.originalFoto || (stand.data && stand.data.originalFoto)) {
        stand = Object.assign({}, stand, { originalFoto: null, data: null });
    }
    const versuche = [
        stand,
        Object.assign({}, stand, { vergleiche: [] })
    ];
    for (let i = 0; i < versuche.length; i++) {
        try {
            localStorage.setItem(STORAGE_KEYS.session, JSON.stringify(versuche[i]));
            if (i > 0) {
                console.warn('Speicher zu klein: Entwurf gesichert, aber der '
                             + 'Vorher-Nachher-Vergleich ueberlebt den Reload nicht.');
            }
            return true;
        } catch (fehler) {
            if (i === versuche.length - 1) {
                console.error('Speichern fehlgeschlagen, der Entwurf ueberlebt '
                              + 'einen Reload nicht:', fehler);
                return false;
            }
        }
    }
    return false;
}

// E-18: das Foto nur im sessionStorage dieses Tabs, mit derselben Ablaufzeit
// wie der Entwurf. Stirbt der Tab, ist es weg; ein Reload ueberlebt es. Der
// Vorher-Nachher-Vergleich braucht es; ohne Foto gibt es nach einem Reload in
// einem neuen Tab eben keinen Vergleich - der Entwurf selbst bleibt.
function sichereFoto(expiresAt) {
    try {
        if (!_originalFoto) { sessionStorage.removeItem(STORAGE_KEYS.foto); return; }
        sessionStorage.setItem(STORAGE_KEYS.foto,
                               JSON.stringify({ foto: _originalFoto, expiresAt: expiresAt || 0 }));
    } catch (e) {
        console.warn('Foto nicht zwischengespeichert; der Vergleich ueberlebt keinen Reload.', e);
    }
}

function ladeFoto() {
    try {
        const roh = sessionStorage.getItem(STORAGE_KEYS.foto);
        if (!roh) return null;
        const eintrag = JSON.parse(roh);
        if (!eintrag || typeof eintrag.foto !== 'string' || !eintrag.foto.startsWith('data:image/')
            || (eintrag.expiresAt && Date.now() > eintrag.expiresAt)) {
            sessionStorage.removeItem(STORAGE_KEYS.foto);
            return null;
        }
        return eintrag.foto;
    } catch (e) {
        return null;
    }
}

function vergissGespeichertenStand() {
    try { localStorage.removeItem(STORAGE_KEYS.session); } catch (e) { /* egal */ }
    try { sessionStorage.removeItem(STORAGE_KEYS.foto); } catch (e) { /* egal */ }
    _originalFoto = null;
}

// E-18: Ablauf per Timer, nicht erst beim naechsten Laden der Seite. Vorher
// blieb ein abgelaufener Stand samt Foto liegen, solange der Tab offen war.
let _ablaufTimer = null;
function planeAblauf(expiresAt) {
    if (_ablaufTimer) clearTimeout(_ablaufTimer);
    const rest = Math.max(0, (expiresAt || 0) - Date.now());
    if (!expiresAt || rest > 0x7fffffff) return;
    _ablaufTimer = setTimeout(() => {
        vergissGespeichertenStand();
        console.log('Gartenplaner: gespeicherter Entwurf ist abgelaufen und wurde entfernt');
    }, rest);
}

// E-18: localStorage ist origin-weit und damit fremdbeschreibbar. Was nicht
// wie ein eigener Stand aussieht, wird verworfen, statt zurueck in Requests
// (sessionId) und ins DOM (Bilder, Texte) zu fliessen.
function speicherstandGueltig(s) {
    const SITZUNG = /^[A-Za-z0-9_-]{8,80}$/;
    const bild = (u) => typeof u === 'string' && u.startsWith('data:image/');
    const text = (t) => typeof t === 'string';
    if (!s || typeof s !== 'object' || Array.isArray(s)) return false;
    if (s.sessionId != null && !(text(s.sessionId) && SITZUNG.test(s.sessionId))) return false;
    if (s.images != null && !(Array.isArray(s.images) && s.images.every(bild))) return false;
    for (const feld of ['alternatives', 'titles', 'descriptions', 'hinweise', 'vergleiche']) {
        if (s[feld] != null && !Array.isArray(s[feld])) return false;
    }
    if (s.titles && !s.titles.every(text)) return false;
    if (s.descriptions && !s.descriptions.every(text)) return false;
    if (s.bildHinweis != null && !text(s.bildHinweis)) return false;
    if (s.expiresAt != null && typeof s.expiresAt !== 'number') return false;
    return true;
}

function displayResults(data) {
    DOM.imageGrid.innerHTML = '';
    DOM.plantAccordions.innerHTML = '';

    const images = normalizeImages(data);
    const alternatives = data.plant_alternatives || [];
    const titles = data.alternative_titles || [];
    const descriptions = data.alternative_descriptions || [];
    // A3: gilt fuer die gesamte Anfrage, nicht je Alternative - das Backend
    // liefert einen Entwurf je Aufruf. Als Liste je Entwurf gefuehrt, damit
    // "Entwurf anpassen" weitere Eintraege danebenlegen kann.
    const hinweise = data.pflanzenhinweise || [];
    // Vorher-Nachher je Entwurf. Steht hier oben, weil renderImageCard()
    // weiter unten danach greift.
    window.gpVergleiche = data.vergleiche || [];
    // B3: MUSS vor dem Rendern stehen - renderNeuentwurfLeiste() liest
    // window.neuentwuerfe. Weiter unten gesetzt zeigte der Zaehler beim ersten
    // Aufbau immer "noch 3 von 3", egal was der Server gemeldet hat.
    window.neuentwuerfe = data.neuentwuerfe || { verbraucht: 0, grenze: 3 };

    DOM.inputSection.classList.add('hidden');

    if (DOM.refineText && !DOM.refineText.value) {
        const currentDesc = DOM.description?.value || '';
        DOM.refineText.value = currentDesc.trim();
    }

    // Lösche alten Cache wenn NEUE Anfrage keine Bilder hat
    // (verhindert Anzeige von alten gecachten Bildern)
    if (images.length === 0) {
        console.warn('Keine Bilder vom Backend erkannt - Bildgenerierung fehlgeschlagen.');
        // Alten Cache löschen damit kein veraltetes Bild angezeigt wird
        const oldCache = localStorage.getItem(STORAGE_KEYS.session);
        if (oldCache) {
            try {
                const oldData = JSON.parse(oldCache);
                if (oldData.images && oldData.images.length > 0) {
                    console.log('Lösche altes gecachtes Bild da Bildgenerierung fehlschlug');
                    oldData.images = [];
                    localStorage.setItem(STORAGE_KEYS.session, JSON.stringify(oldData));
                }
            } catch (e) {
                console.error('Cache-Bereinigung fehlgeschlagen:', e);
            }
        }

        // Zeige Hinweis-Karte statt Bild
        const apiTitle = (titles[0] && String(titles[0]).trim()) || null;
        // SECURITY: Escape title to prevent XSS
        const title = escapeHtml(apiTitle || 'Dein Gartenplan');
        // B-03: seit 09.09.2026 meldet der Server status 'partial' mit einem
        // Hinweistext, wenn die Liste ohne Bild kommt. Der Text kommt vom
        // Server, nicht vom Modell - trotzdem escaped, weil er ueber den
        // Speicherstand zurueckkommen kann.
        const serverHinweis = (data.status === 'partial' && data.hinweis) ? String(data.hinweis) : '';
        const hinweisHtml = serverHinweis
            ? escapeHtml(serverHinweis)
            : 'Die KI-Bildgenerierung ist derzeit nicht verfügbar.<br>Die Pflanzempfehlungen sind trotzdem vollständig!';
        const noImageCard = document.createElement('div');
        noImageCard.className = 'image-card image-card-no-image';
        noImageCard.setAttribute('data-alt-index', '1');
        noImageCard.innerHTML = `
            <div class="no-image-placeholder" style="background:#f8f9fa;border:2px dashed #dee2e6;border-radius:12px;padding:40px 20px;text-align:center;min-height:200px;display:flex;flex-direction:column;align-items:center;justify-content:center;">
                <div style="font-size:48px;margin-bottom:16px;">🌱</div>
                <p style="color:#6c757d;margin:0 0 8px;font-weight:600;">Bild konnte nicht erzeugt werden</p>
                <p class="bild-hinweis" style="color:#6c757d;margin:0;font-size:13px;">${hinweisHtml}</p>
            </div>
            <h4>${title}</h4>
        `;
        DOM.imageGrid.appendChild(noImageCard);
        alternativesCount = 1;

        // Toast-Hinweis
        toast(serverHinweis || 'Hinweis: Bildgenerierung derzeit nicht verfügbar', '#f59e0b');
    }

    if (images.length > 0) {
        const imgDataUri = images[0];
        const apiTitle = (titles[0] && String(titles[0]).trim()) || null;
        const title = apiTitle || 'Dein Gartenplan';
        const altIdx = 1;

        const card = renderImageCard(imgDataUri, title, altIdx);
        DOM.imageGrid.appendChild(card);
        ruesteVergleichNach(card, altIdx);
        alternativesCount = 1;
    }

    if (alternatives.length > 0) {
        const alternative = alternatives[0];
        const altIdx = 1;
        const apiTitle = (titles[0] && String(titles[0]).trim()) || null;
        const title = apiTitle || 'Gartenplan';
        const description = descriptions[0] || '';

        const accordion = renderPlantAccordion(alternative, title, description, altIdx, hinweise);
        DOM.plantAccordions.appendChild(accordion);
    }

    window.plantAlternatives = alternatives;
    window.pflanzenhinweise = [hinweise];

    // Neuer Entwurf: alte "im Warenkorb"-Vermerke gelten nicht mehr.
    clearAddedAlternatives();
    syncCartButtons();

    DOM.results.classList.add('show');
    DOM.results.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (DOM.createAdditionalBtn && alternativesCount < CONFIG.MAX_ALTERNATIVES) {
        DOM.createAdditionalBtn.style.display = 'block';
    } else if (DOM.createAdditionalBtn) {
        DOM.createAdditionalBtn.style.display = 'none';
    }

    saveToStorage(data, images, alternatives, titles, descriptions, [hinweise]);

    setTimeout(() => initImageZoom(), 100);
}

function appendVariant(data) {
    const currentCount = DOM.imageGrid.querySelectorAll('.image-card').length;
    const idx = currentCount + 1;
    const imgs = normalizeImages(data);
    const img = imgs[0];

    const apiTitle = (data.alternative_titles && data.alternative_titles[0])
        ? String(data.alternative_titles[0]).trim()
        : null;
    const title = apiTitle || `Alternative ${idx}`;

    if (img) {
        if (Array.isArray(data.vergleiche) && data.vergleiche[0]) {
            window.gpVergleiche = window.gpVergleiche || [];
            window.gpVergleiche[idx - 1] = data.vergleiche[0];
        }
        const card = renderImageCard(img, title, idx);
        DOM.imageGrid.appendChild(card);
        ruesteVergleichNach(card, idx);
        _lastImageDataUri = String(img);
        alternativesCount = idx;
    } else {
        // Zeige Hinweis-Karte wenn kein Bild generiert wurde
        console.warn('Keine Bilder für Variante generiert - Bildgenerierung fehlgeschlagen.');
        // SECURITY: Escape title to prevent XSS
        const safeTitle = escapeHtml(title);
        const noImageCard = document.createElement('div');
        noImageCard.className = 'image-card image-card-no-image';
        noImageCard.setAttribute('data-alt-index', idx);
        noImageCard.innerHTML = `
            <div class="no-image-placeholder" style="background:#f8f9fa;border:2px dashed #dee2e6;border-radius:12px;padding:40px 20px;text-align:center;min-height:200px;display:flex;flex-direction:column;align-items:center;justify-content:center;">
                <div style="font-size:48px;margin-bottom:16px;">🌱</div>
                <p style="color:#6c757d;margin:0 0 8px;font-weight:600;">Bildgenerierung fehlgeschlagen</p>
                <p style="color:#adb5bd;margin:0;font-size:13px;">Die KI-Bildgenerierung ist derzeit nicht verfügbar.</p>
            </div>
            <h4>${safeTitle}</h4>
        `;
        DOM.imageGrid.appendChild(noImageCard);
        alternativesCount = idx;
        toast('Hinweis: Bildgenerierung derzeit nicht verfügbar', '#f59e0b');
    }

    const alt = (data.plant_alternatives || [])[0] || null;
    const description = (data.alternative_descriptions || [])[0] || '';
    const hinweise = data.pflanzenhinweise || [];
    if (data.neuentwuerfe) window.neuentwuerfe = data.neuentwuerfe;

    if (alt) {
        const accordion = renderPlantAccordion(alt, title, description, idx, hinweise);
        DOM.plantAccordions.appendChild(accordion);

        window.plantAlternatives = (window.plantAlternatives || []);
        window.plantAlternatives[idx - 1] = alt;
        window.pflanzenhinweise = (window.pflanzenhinweise || []);
        window.pflanzenhinweise[idx - 1] = hinweise;
        // Kein clearAddedAlternatives(): hier kommt ein Entwurf DAZU, die
        // bereits hinzugefuegten bleiben gueltig.
        syncCartButtons();
    }

    try {
        const saved = localStorage.getItem(STORAGE_KEYS.session);
        let storageData;

        if (saved) {
            storageData = JSON.parse(saved);
            if (!storageData.images) storageData.images = [];
            if (!storageData.alternatives) storageData.alternatives = [];
            if (!storageData.titles) storageData.titles = [];
            if (!storageData.descriptions) storageData.descriptions = [];
            if (!storageData.hinweise) storageData.hinweise = [];

            if (img) storageData.images.push(img);
            if (alt) storageData.alternatives.push(alt);
            if (title) storageData.titles.push(title);
            if (description) storageData.descriptions.push(description);
            if (alt) storageData.hinweise.push(hinweise);
        } else {
            storageData = {
                images: img ? [img] : [],
                alternatives: alt ? [alt] : [],
                titles: title ? [title] : [],
                descriptions: description ? [description] : [],
                hinweise: alt ? [hinweise] : [],
                timestamp: Date.now(),
                expiresAt: Date.now() + CONFIG.CACHE_DURATION_MS
            };
        }

        localStorage.setItem(STORAGE_KEYS.session, JSON.stringify(storageData));
    } catch (e) {
        console.error('Storage error:', e);
    }

    const totalCount = document.querySelectorAll('#imageGrid .image-card').length;
    if (totalCount >= CONFIG.MAX_ALTERNATIVES) {
        if (DOM.createAdditionalBtn) DOM.createAdditionalBtn.style.display = 'none';
        toast(`Maximal ${CONFIG.MAX_ALTERNATIVES} Alternativen erreicht`, '#2FAE55');
    } else {
        if (DOM.createAdditionalBtn) DOM.createAdditionalBtn.style.display = 'block';
    }

    setTimeout(() => initImageZoom(), 100);
}

// ============================================================================
// CART FUNCTIONALITY
// ============================================================================

async function updateCartCount() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const els = document.querySelectorAll('[data-cart-count], .cart-count, #cart-count');
        els.forEach(el => { el.textContent = cart.item_count; });
    } catch (e) {
        console.error('Failed to update cart count:', e);
    }
}

async function addAlternativeToCart(alternativeIndex) {
    if (!window.plantAlternatives || !window.plantAlternatives[alternativeIndex - 1]) {
        console.error('Alternative nicht gefunden');
        return;
    }

    const alternative = window.plantAlternatives[alternativeIndex - 1];

    const allButtons = document.querySelectorAll(`button[data-aktion="warenkorb"][data-alt-index="${alternativeIndex}"]`);

    allButtons.forEach(btn => {
        btn.disabled = true;
        btn.textContent = 'Wird hinzugefügt...';
    });

    try {
        // Anzahl 0 heisst "vom Kunden entfernt" und gehoert nicht in den
        // Warenkorb - Shopify wuerde eine Position mit quantity 0 ohnehin
        // abweisen und den ganzen Aufruf scheitern lassen.
        const items = alternative
            .filter(row => row.Pflanze !== 'SUMME' && row.variant_id)
            .map(row => ({ id: row.variant_id, quantity: parseInt(row.Anzahl, 10) || 0 }))
            .filter(row => row.quantity > 0);

        if (window.location.protocol === 'file:') {
            return new Promise(resolve => {
                setTimeout(() => {
                    markAlternativeAsAdded(alternativeIndex);
                    updateCartButtons(alternativeIndex, true);
                    toast(`LOKALER TEST: Warenkorb-Simulation erfolgreich.`, CONFIG.COLORS.success);
                    resolve();
                }, 500);
            });
        }

        if (items.length === 0) {
            throw new Error('Keine gültigen Produkte mit Variant ID gefunden');
        }

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.description || 'Fehler beim Hinzufügen zum Warenkorb');
        }

        await response.json();

        markAlternativeAsAdded(alternativeIndex);
        updateCartButtons(alternativeIndex, true);
        updateCartCount();
        meldeWarenkorbKlick(alternativeIndex, items, alternative);

        toast('Zum Warenkorb hinzugefügt!', CONFIG.COLORS.success);
    } catch (error) {
        console.error('Cart error:', error);
        updateCartButtons(alternativeIndex, false);
        toast('Fehler: ' + error.message, CONFIG.COLORS.error);
    }
}

// Gleicht die Warenkorb-Buttons mit dem TATSAECHLICHEN Warenkorb ab.
// Ein Entwurf gilt nur dann als "im Warenkorb", wenn ALLE seine Variant-IDs
// dort liegen. Ist /cart.js nicht erreichbar, faellt die Pruefung auf die
// Rueckmeldung dieser Sitzung zurueck - und im Zweifel bleibt der Button
// klickbar, statt den Kauf zu blockieren.
async function syncCartButtons() {
    const alts = window.plantAlternatives || [];
    if (!alts.length) return;

    // Erst alles in den aktiven Zustand, damit kein alter Stand stehen bleibt.
    alts.forEach((alt, i) => updateCartButtons(i + 1, false));

    // B4: es wird die MENGE verglichen, nicht nur die Anwesenheit. Vorher
    // genuegte "alle IDs liegen im Warenkorb" - seit der Kunde Stueckzahlen
    // bearbeitet, waere der Button dann auch dann grau, wenn im Warenkorb
    // drei Hortensien liegen und in seiner Liste fuenf stehen.
    let mengenImCart = null;
    try {
        const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (response.ok) {
            const cart = await response.json();
            mengenImCart = new Map();
            (cart.items || []).forEach(item => {
                const id = String(item.variant_id != null ? item.variant_id : item.id)
                    .replace(/\.0$/, '').trim();
                const anzahl = parseInt(item.quantity, 10);
                if (!id) return;
                // Shopify fuehrt dieselbe Variante als eine Zeile, aber ein
                // zweites Hinzufuegen erhoeht nur die Menge - summieren ist
                // trotzdem richtiger als ueberschreiben.
                mengenImCart.set(id, (mengenImCart.get(id) || 0) +
                    (isFinite(anzahl) ? anzahl : 0));
            });
        }
    } catch (e) {
        mengenImCart = null;
    }

    alts.forEach((alt, i) => {
        const idx = i + 1;
        const mengen = getAlternativeMengen(alt);
        if (!mengen.length) return;
        if (mengenImCart) {
            const vollstaendig = mengen.every(eintrag => {
                const [id, anzahl] = eintrag.split(':');
                return (mengenImCart.get(id) || 0) >= parseInt(anzahl, 10);
            });
            if (vollstaendig) updateCartButtons(idx, true);
        } else if (isAlternativeAdded(idx)) {
            updateCartButtons(idx, true);
        }
    });
}

// H.4.2: Meldet dem Dienst, dass ein Entwurf in den Warenkorb gelegt wurde.
// Absichtlich ohne await und mit leerem catch - ein fehlgeschlagener Zaehler
// darf den Warenkorb nicht stoeren. Uebertragen werden nur Kennzahlen des
// Entwurfs, keine Personendaten.
function meldeWarenkorbKlick(alternativeIndex, items, alternative) {
    if (!window.gpSessionId) return;
    let wert = null;
    try {
        const summe = (alternative || []).find(r => r && r.Pflanze === 'SUMME');
        if (summe && summe.Gesamt) {
            wert = parseFloat(String(summe.Gesamt).replace(/[^0-9,.-]/g, '')
                .replace(/\./g, '').replace(',', '.'));
            if (!isFinite(wert)) wert = null;
        }
    } catch (e) { wert = null; }

    try {
        fetch(getApiBaseUrl() + '/api/cart_event', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                session_id: window.gpSessionId,
                alternative: alternativeIndex,
                positionen: items.length,
                stueck: items.reduce((s, i) => s + (Number(i.quantity) || 0), 0),
                warenkorbwert: wert
            })
        }).catch(() => {});
    } catch (e) { /* egal */ }
}

function updateCartButtons(alternativeIndex, isAdded) {
    const allButtons = document.querySelectorAll(`button[data-aktion="warenkorb"][data-alt-index="${alternativeIndex}"]`);

    allButtons.forEach(btn => {
        if (isAdded) {
            btn.textContent = 'Im Warenkorb';
            btn.classList.add('added-to-cart');
            btn.setAttribute('data-added', 'true');
            btn.disabled = true;
        } else {
            btn.textContent = 'In den Warenkorb';
            btn.classList.remove('added-to-cart');
            btn.removeAttribute('data-added');
            btn.disabled = false;
        }
    });
}

window.addAlternativeToCart = addAlternativeToCart;

// ============================================================================
// B: ENTWURF NEU GENERIEREN
// ============================================================================

// Ersetzt den Entwurf an SEINEM Platz. appendVariant() haengt an - das waere
// hier falsch: die Galerie wuchse bei jedem Neuentwurf, und die Zaehlung
// gegen MAX_ALTERNATIVES braeche.
function ersetzeEntwurf(altIdx, data) {
    const bilder = normalizeImages(data);
    const liste = (data.plant_alternatives || [])[0] || null;
    const titel = (data.alternative_titles || [])[0] || 'Gartenplan';
    const beschreibung = (data.alternative_descriptions || [])[0] || '';
    const hinweise = data.pflanzenhinweise || [];

    if (data.neuentwuerfe) window.neuentwuerfe = data.neuentwuerfe;

    window.plantAlternatives = window.plantAlternatives || [];
    window.plantAlternatives[altIdx - 1] = liste;
    window.pflanzenhinweise = window.pflanzenhinweise || [];
    window.pflanzenhinweise[altIdx - 1] = hinweise;

    // Das Foto bleibt, der Entwurf ist neu - die Ausrichtung kommt deshalb
    // frisch aus der Antwort.
    if (Array.isArray(data.vergleiche)) {
        window.gpVergleiche = window.gpVergleiche || [];
        window.gpVergleiche[altIdx - 1] = data.vergleiche[0] || null;
    }

    const alteKarte = DOM.imageGrid.querySelector(`.image-card[data-alt-index="${altIdx}"]`);
    if (alteKarte && bilder[0]) {
        const neueKarte = renderImageCard(bilder[0], titel, altIdx);
        alteKarte.replaceWith(neueKarte);
        ruesteVergleichNach(neueKarte, altIdx);
        _lastImageDataUri = String(bilder[0]);
    }

    const altesAkkordeon = DOM.plantAccordions.querySelector(`details[data-alt-index="${altIdx}"]`);
    if (altesAkkordeon && liste) {
        const neuesAkkordeon = renderPlantAccordion(liste, titel, beschreibung, altIdx, hinweise);
        altesAkkordeon.replaceWith(neuesAkkordeon);
    }

    // Die Variant-Mengen haben sich geaendert - der alte "im Warenkorb"-Vermerk
    // gilt nicht mehr. syncCartButtons() prueft anschliessend gegen den echten
    // Warenkorb, ob er doch noch passt.
    syncCartButtons();

    // Gespeicherten Stand nachziehen, sonst zeigt ein Reload den alten Entwurf.
    try {
        const gespeichert = localStorage.getItem(STORAGE_KEYS.session);
        if (gespeichert) {
            const daten = JSON.parse(gespeichert);
            if (bilder[0] && Array.isArray(daten.images)) daten.images[altIdx - 1] = bilder[0];
            if (liste && Array.isArray(daten.alternatives)) daten.alternatives[altIdx - 1] = liste;
            if (Array.isArray(daten.titles)) daten.titles[altIdx - 1] = titel;
            if (Array.isArray(daten.descriptions)) daten.descriptions[altIdx - 1] = beschreibung;
            if (!Array.isArray(daten.hinweise)) daten.hinweise = [];
            daten.hinweise[altIdx - 1] = hinweise;
            daten.neuentwuerfe = window.neuentwuerfe;
            localStorage.setItem(STORAGE_KEYS.session, JSON.stringify(daten));
        }
    } catch (e) {
        console.error('Storage error:', e);
    }

    setTimeout(() => initImageZoom(), 100);
}

// Blendet einen Entwurf ab, solange er neu gezeichnet wird. Betrifft Bildkarte
// und Pflanzliste gleichermassen - beide werden ersetzt.
function markiereInArbeit(altIdx, anEinAus) {
    const teile = [
        DOM.imageGrid.querySelector(`.image-card[data-alt-index="${altIdx}"]`),
        DOM.plantAccordions.querySelector(`details[data-alt-index="${altIdx}"]`)
    ];
    teile.forEach(el => {
        if (!el) return;
        el.classList.toggle('wird-erneuert', !!anEinAus);
        // inert statt nur pointer-events: sperrt auch Tastatur und
        // Vorlesewerkzeuge, sonst kann man sich per Tab in einen Entwurf
        // hineinbewegen, den es gleich nicht mehr gibt.
        if ('inert' in HTMLElement.prototype) el.inert = !!anEinAus;
    });
}

async function regenerateDraft(altIdx) {
    if (activeRequest) {
        console.log('Request läuft bereits, ignoriere Klick');
        return;
    }
    if (!window.gpSessionId) {
        toast('Dieser Entwurf lässt sich nicht neu erzeugen. Bitte neu starten.',
              CONFIG.COLORS.error);
        return;
    }

    const positionen = leseMengen(altIdx);
    if (positionen.length === 0) {
        toast('Keine Pflanzen in der Liste.', CONFIG.COLORS.error);
        return;
    }
    if (positionen.every(p => p.anzahl === 0)) {
        toast('Mindestens eine Pflanze muss im Entwurf bleiben.', CONFIG.COLORS.error);
        return;
    }

    const knopf = document.querySelector(
        `.neuentwurf-leiste[data-alt-index="${altIdx}"] .btn-neuentwurf`);
    const altText = knopf ? knopf.textContent : '';
    if (knopf) {
        knopf.disabled = true;
        knopf.textContent = 'Wird erstellt...';
    }

    activeRequest = true;

    // Ladekarte wie beim ersten Entwurf - aber der bisherige Entwurf BLEIBT
    // stehen.
    //
    // Erst wurde er ausgeblendet, weil "dieselbe Darstellung wie bei der
    // ersten Erstellung" verlangt war. Das war zu woertlich: beim ersten Mal
    // gibt es nichts zu zeigen, hier schon. Ihn wegzunehmen kostet den
    // Zusammenhang - der Kunde sieht nicht mehr, was er gerade geaendert hat -
    // und hinterlaesst eine leere Seite ueber dem Fuss.
    //
    // Stattdessen: abgeblendet und nicht bedienbar, damit klar ist, dass er
    // gerade ersetzt wird und ein zweiter Klick nichts bringt.
    markiereInArbeit(altIdx, true);
    DOM.loadingDiv.classList.add('show');
    DOM.loadingDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    startProgress(CONFIG.NEUENTWURF_DURATION_MS, CONFIG.NEUENTWURF_MESSAGES);
    // "bis zu 2 Minuten" gilt fuer den ersten Lauf. Der Neuentwurf spart
    // Bildanalyse, Intent und Ranking und ist gemessen etwa halb so lang.
    if (DOM.loadingHint) DOM.loadingHint.textContent = 'Das dauert etwa eine Minute.';

    try {
        await acquireWakeLock();

        const start = await fetchWithRetry(getApiBaseUrl() + '/api/regenerate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ session_id: window.gpSessionId, positionen })
        });
        const startDaten = await start.json();

        if (startDaten.status === 'error') {
            if (startDaten.neuentwuerfe) window.neuentwuerfe = startDaten.neuentwuerfe;
            throw new Error(startDaten.error || 'Unbekannter Fehler');
        }
        if (startDaten.status !== 'accepted' || !startDaten.job_id) {
            throw new Error('Unerwartete Server-Antwort');
        }
        if (startDaten.neuentwuerfe) window.neuentwuerfe = startDaten.neuentwuerfe;

        // Dieselbe Job-Mechanik wie beim ersten Entwurf - damit traegt der
        // Neuentwurf den mobilen Verbindungsabbruch ohne neuen Code.
        const ergebnis = await pollJobResult(startDaten.job_id);
        ersetzeEntwurf(altIdx, ergebnis);
        doneProgress();
        toast('Neuer Entwurf erstellt!', CONFIG.COLORS.success);
        // Zum neuen Entwurf zurueck, nicht dorthin, wo die Ladekarte stand.
        DOM.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (fehler) {
        console.error('Regenerate error:', fehler);
        doneProgress();
        if (!handleRateLimitError(fehler)) {
            toast('Fehler: ' + fehler.message, CONFIG.COLORS.error);
        }
        // Zaehlerstand kann sich geaendert haben - Leiste neu zeichnen.
        //
        // Der Ausgangsstand wird dabei UEBERNOMMEN, nicht neu berechnet:
        // uebernimmMenge() hat die Aenderung des Kunden bereits in
        // window.plantAlternatives geschrieben. Wuerde die Leiste ihre Basis
        // von dort neu lesen, waere sie mit dem aktuellen Stand identisch und
        // der Knopf ginge aus - der Kunde koennte seine Aenderung nach einem
        // Fehler nicht noch einmal abschicken.
        const leiste = document.querySelector(
            `.neuentwurf-leiste[data-alt-index="${altIdx}"]`);
        if (leiste) {
            const basis = leiste.dataset.basis || '';
            leiste.outerHTML = renderNeuentwurfLeiste(
                altIdx, (window.plantAlternatives || [])[altIdx - 1]);
            const neueLeiste = document.querySelector(
                `.neuentwurf-leiste[data-alt-index="${altIdx}"]`);
            if (neueLeiste) {
                neueLeiste.dataset.basis = basis;
                pruefeAenderung(altIdx);
            }
        }
    } finally {
        DOM.loadingDiv.classList.remove('show');
        // Unbedingt zuruecknehmen - auch nach einem Fehler. Sonst bleibt der
        // Entwurf abgeblendet und unbedienbar zurueck.
        markiereInArbeit(altIdx, false);
        DOM.results.classList.add('show');
        resetProgress();
        activeRequest = null;
        await releaseWakeLock();
        localStorage.removeItem('pending_job_id');
        const jetzt = document.querySelector(
            `.neuentwurf-leiste[data-alt-index="${altIdx}"] .btn-neuentwurf`);
        if (jetzt && jetzt.textContent === 'Wird erstellt...') {
            jetzt.disabled = false;
            jetzt.textContent = altText;
        }
    }
}

window.regenerateDraft = regenerateDraft;

// ============================================================================
// PDF
// ----------------------------------------------------------------------------
// Das Blatt wird aus DATEN gesetzt, nicht vom Bildschirm abfotografiert.
//
// Bis zum 08.09.2026 lief das ueber html2canvas: der Akkordeon-Inhalt wurde in
// eine Rastergrafik gerendert und als JPEG eingefuegt. Messung an einem echten
// Ausdruck: 26 Zeichen auslesbarer Text im GANZEN Dokument ("Pflanzenplaner",
// "Alternative 1"), 7 Bilder, 0 Schriften, 857 KB. Kein Pflanzenname, kein
// Preis, kein Satz der Beschreibung war Text.
//
// Die Folgen waren nicht kosmetisch:
//   * Die Bedienelemente standen mit im PDF - Stueckzahl-Stepper, das leere
//     Suchfeld, der Knopf "Entwurf neu berechnen". Entfernt wurde vor dem
//     Abfotografieren genau ein Element (.btn-add-to-cart); alles, was spaeter
//     dazukam, landete automatisch im Ausdruck. Eine Bauart, die bei jeder
//     neuen Bedienung erneut kaputtgeht.
//   * Nichts war markierbar, kopierbar oder durchsuchbar.
//   * Die Tabelle ging als EIN Block ins Dokument. Passte sie nicht mehr aufs
//     Blatt, sprang sie komplett auf die naechste Seite - daher zwei Drittel
//     weisse Flaeche auf Seite 1.
//
// Jetzt wird gesetzt. Neue Bedienelemente koennen gar nicht mehr hineinrutschen,
// weil nichts mehr aus dem DOM kommt.
// ============================================================================

// P8: Das Entwurfsbild zeigt ausgewachsene Pflanzen, geliefert wird
// Containerware - zwischen beidem liegen drei bis fuenf Jahre. Steht der
// Hinweis nirgends, merkt der Kunde es erst beim Auspacken.
//
// Dieser volle Satz steht seit dem 10.09.2026 nur noch im PDF, wo Platz fuer
// ihn ist. Auf der Seite traegt ihn die Marke .gp-wuchsmarke oben links IM
// Bild - dort, wo die Behauptung steht, die sie einschraenkt. Kommt ein
// Vorher-Nachher-Vergleich dazu, uebernimmt die Marke "Nachher" den Zusatz
// und .gp-wuchsmarke verschwindet (siehe dort).
//
// Erster Versuch am selben Tag war, die Wuchszeit an die Marke "Nachher" zu
// haengen. Das war falsch: die Marken entstehen nur, wenn ein Vorher-Nachher-
// Vergleich zustande kommt. Ohne Foto gibt es keinen Vergleich, keine Marke -
// und der Hinweis stand nirgends. .gp-wuchsmarke haengt dagegen an jeder
// Bildkarte.
const WUCHSHINWEIS = 'Die Visualisierung zeigt die Bepflanzung nach 3 bis 5 Jahren '
    + 'Wuchszeit. Geliefert wird kräftige Containerware in der angegebenen Größe.';

const PDF_GRUEN = [21, 135, 63];        // --baumfink-green-dark #15873F
const PDF_GRAU = [110, 105, 96];
const PDF_HELL = [244, 250, 246];
const PDF_LINIE = [222, 226, 219];

// Assistant ist die Schrift des Shops. jsPDF braucht TTF - die CSS-Schnittstelle
// von Google liefert einem echten Browser aber woff2, das jsPDF nicht lesen
// kann. Deshalb die TTF-Adressen fest. Aendert Google die Fassung, schlaegt der
// Abruf fehl und das Blatt wird in Helvetica gesetzt: schlichter, aber
// vollstaendig. Kein Grund, den Download scheitern zu lassen.
const PDF_SCHRIFT = {
    normal: 'https://fonts.gstatic.com/s/assistant/v24/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtuZnEGE.ttf',
    fett:   'https://fonts.gstatic.com/s/assistant/v24/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtgFgEGE.ttf'
};

async function alsBase64(url) {
    const antwort = await fetch(url, { mode: 'cors' });
    if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
    const puffer = await antwort.arrayBuffer();
    let roh = '';
    const bytes = new Uint8Array(puffer);
    for (let i = 0; i < bytes.length; i += 0x8000) {
        roh += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
    }
    return btoa(roh);
}

// Bettet Assistant ein. Gibt den Namen der zu verwendenden Schrift zurueck.
async function ladePdfSchrift(pdf) {
    try {
        const [normal, fett] = await Promise.all([
            alsBase64(PDF_SCHRIFT.normal), alsBase64(PDF_SCHRIFT.fett)
        ]);
        pdf.addFileToVFS('Assistant-Regular.ttf', normal);
        pdf.addFont('Assistant-Regular.ttf', 'Assistant', 'normal');
        pdf.addFileToVFS('Assistant-Bold.ttf', fett);
        pdf.addFont('Assistant-Bold.ttf', 'Assistant', 'bold');
        return 'Assistant';
    } catch (fehler) {
        console.warn('PDF: Schrift nicht ladbar, setze in Helvetica.', fehler);
        return 'helvetica';
    }
}

// Handle aus dem Produktlink: .../products/<handle>?variant=...
function handleAusLink(url) {
    const treffer = String(url || '').match(/\/products\/([^/?#]+)/);
    return treffer ? treffer[1].toLowerCase() : null;
}

// Kleine quadratische Vorschaubilder je Pflanze. Die Adressen stehen im
// Suchindex, den die Katalogsuche ohnehin laedt.
async function ladeProduktbilder(liste) {
    const bilder = {};
    try {
        if (!suchindexDaten) await ladeSuchindex();
    } catch (fehler) {
        console.warn('PDF: Suchindex nicht verfuegbar, Tabelle ohne Bilder.', fehler);
        return bilder;
    }
    if (!suchindexDaten) return bilder;

    const nachHandle = {};
    suchindexDaten.forEach(e => { if (!nachHandle[e.handle]) nachHandle[e.handle] = e.image_url; });

    const auftraege = liste
        .filter(z => z && z.Pflanze !== 'SUMME')
        .map(z => handleAusLink(z.product_url))
        .filter((h, i, a) => h && nachHandle[h] && a.indexOf(h) === i);

    await Promise.all(auftraege.map(async (handle) => {
        try {
            const antwort = await fetch(nachHandle[handle], { mode: 'cors' });
            if (!antwort.ok) return;
            const bild = await createImageBitmap(await antwort.blob());
            // Quadratisch beschneiden, damit die Spalte ruhig wirkt.
            const kante = Math.min(bild.width, bild.height);
            const leinwand = document.createElement('canvas');
            leinwand.width = leinwand.height = 120;
            leinwand.getContext('2d').drawImage(
                bild, (bild.width - kante) / 2, (bild.height - kante) / 2, kante, kante,
                0, 0, 120, 120);
            bild.close();
            bilder[handle] = leinwand.toDataURL('image/jpeg', 0.8);
        } catch (fehler) {
            console.warn('PDF: Bild fuer ' + handle + ' nicht ladbar.', fehler);
        }
    }));
    return bilder;
}

// Fotos fuer das PDF neu berechnen. Das Blatt zeigt sie 180 mm breit; bei
// 150 dpi sind das rund 1060 Pixel. Das Original unveraendert einzubetten
// machte das Dokument ohne jeden sichtbaren Gewinn dreimal so schwer - und ein
// Gartenplan, den man Freunden schickt, soll nicht am Anhang scheitern.
function verkleinereFuerPdf(quelle, maxBreite = 1200, guete = 0.82) {
    return new Promise((erfuellen) => {
        if (!quelle) return erfuellen(null);
        const bild = new Image();
        bild.onload = () => {
            try {
                const faktor = Math.min(1, maxBreite / bild.naturalWidth);
                const leinwand = document.createElement('canvas');
                leinwand.width = Math.round(bild.naturalWidth * faktor);
                leinwand.height = Math.round(bild.naturalHeight * faktor);
                leinwand.getContext('2d').drawImage(bild, 0, 0, leinwand.width, leinwand.height);
                erfuellen(leinwand.toDataURL('image/jpeg', guete));
            } catch (fehler) {
                console.warn('PDF: Bild nicht verkleinerbar, nehme das Original.', fehler);
                erfuellen(quelle);
            }
        };
        bild.onerror = () => erfuellen(quelle);
        bild.src = quelle;
    });
}

function pdfLogo() {
    return new Promise((erfuellen) => {
        const bild = new Image();
        bild.crossOrigin = 'Anonymous';
        bild.onload = () => erfuellen(bild);
        bild.onerror = () => erfuellen(null);
        bild.src = 'https://baumfink.de/cdn/shop/files/Baumfink_Logo_14_171x221.png?v=1685520878';
    });
}

async function generatePDF() {
    if (!window.plantAlternatives || window.plantAlternatives.length === 0) {
        toast('Bitte zuerst einen Gartenplan erstellen.', CONFIG.COLORS.error);
        return;
    }

    const knopf = DOM.pdfDownloadBtn;
    const altText = knopf ? knopf.innerHTML : '';
    if (knopf) { knopf.disabled = true; knopf.textContent = '…'; }

    try {
        const { jsPDF } = window.jspdf;
        const pdf = new jsPDF('p', 'mm', 'a4');
        const seiteBreite = pdf.internal.pageSize.getWidth();
        const seiteHoehe = pdf.internal.pageSize.getHeight();
        const rand = 15;
        const breite = seiteBreite - 2 * rand;

        const schrift = await ladePdfSchrift(pdf);
        const logo = await pdfLogo();

        const setz = (groesse, stil, farbe) => {
            pdf.setFont(schrift, stil || 'normal');
            pdf.setFontSize(groesse);
            pdf.setTextColor.apply(pdf, farbe || [40, 38, 34]);
        };

        const seiten = [];   // fuer die Fussnoten am Ende
        const fussnote = () => seiten.push(pdf.getNumberOfPages());

        const liste = window.plantAlternatives[0] || [];
        const titel = (document.querySelector('#plantAccordions summary span')?.textContent
                       || 'Dein Gartenplan').trim();
        const bildKarte = document.querySelector('#imageGrid .image-card .thumb');
        const vorherBild = document.querySelector('#imageGrid .image-card .vorher-bild');
        const [nachher, vorher] = await Promise.all([
            verkleinereFuerPdf(bildKarte ? bildKarte.src : null),
            verkleinereFuerPdf(vorherBild ? vorherBild.src : null, 800)
        ]);

        // ---------------------------------------------------------------
        // SEITE 1: das Blatt, das man herzeigt
        // ---------------------------------------------------------------
        let y = rand;

        if (logo) {
            const h = 14, b = (logo.width / logo.height) * h;
            pdf.addImage(logo, 'PNG', rand, y, b, h);
        }
        setz(9, 'normal', PDF_GRAU);
        pdf.text(new Date().toLocaleDateString('de-DE',
            { day: '2-digit', month: 'long', year: 'numeric' }),
            seiteBreite - rand, y + 6, { align: 'right' });
        pdf.text('baumfink.de', seiteBreite - rand, y + 11, { align: 'right' });

        y += 22;
        setz(20, 'bold', PDF_GRUEN);
        const titelZeilen = pdf.splitTextToSize(titel, breite);
        pdf.text(titelZeilen, rand, y);
        y += titelZeilen.length * 8 + 1;

        setz(10, 'normal', PDF_GRAU);
        pdf.text('Dein persönlicher Gartenentwurf', rand, y);
        y += 8;

        // Grosses Nachher-Bild
        if (nachher) {
            const hoehe = breite * 9 / 16;
            pdf.addImage(nachher, 'JPEG', rand, y, breite, hoehe);
            y += hoehe + 4;
            setz(9, 'bold', PDF_GRUEN);
            pdf.text('NACHHER — so könnte dein Garten aussehen', rand, y);
            y += 5;
            // P8: Das Bild zeigt ausgewachsene Pflanzen, geliefert wird
            // Containerware. Ohne diesen Satz ist die Enttaeuschung beim
            // Auspacken vorprogrammiert - und die Retoure gleich mit.
            setz(7.5, 'normal', PDF_GRAU);
            pdf.text(WUCHSHINWEIS, rand, y);
            y += 6;
        }

        // Vorher-Bild links, Kennzahlen rechts
        const kennzahlenX = vorher ? rand + breite * 0.5 + 6 : rand;
        if (vorher) {
            const vb = breite * 0.5 - 3;
            const vh = vb * 9 / 16;
            pdf.addImage(vorher, 'JPEG', rand, y, vb, vh);
            setz(8, 'normal', PDF_GRAU);
            pdf.text('VORHER — dein Foto', rand, y + vh + 4);
        }

        const hinweisTexte = [...document.querySelectorAll('#plantAccordions .pflanzenhinweise li')]
            .map(el => (el.textContent || '').trim()).filter(Boolean);

        const zahlen = pdfKennzahlen(liste);
        let ky = y + 3;
        zahlen.forEach(([bez, wert]) => {
            setz(8, 'normal', PDF_GRAU);
            pdf.text(bez, kennzahlenX, ky);
            setz(13, 'bold', PDF_GRUEN);
            pdf.text(wert, kennzahlenX, ky + 6);
            ky += 14;
        });

        // Was der Kunde gewuenscht und nicht bekommen hat, gehoert auch aufs
        // Papier. Auf dem Bildschirm steht es unter der Liste; hier ist Platz
        // dafuer, und ohne den Hinweis waere der Ausdruck weniger ehrlich als
        // die Seite, aus der er entstanden ist.
        if (hinweisTexte.length) {
            let hy = Math.max(ky, y + 62);
            if (hy < seiteHoehe - 40) {
                pdf.setFillColor.apply(pdf, PDF_HELL);
                const kastenHoehe = 8 + hinweisTexte.length * 9;
                pdf.rect(rand, hy, breite, kastenHoehe, 'F');
                setz(8, 'bold', PDF_GRUEN);
                pdf.text('DAZU EIN HINWEIS', rand + 4, hy + 6);
                setz(9, 'normal', PDF_GRAU);
                let ty = hy + 12;
                hinweisTexte.forEach(t => {
                    pdf.splitTextToSize(t, breite - 8).slice(0, 2).forEach(zeile => {
                        pdf.text(zeile, rand + 4, ty);
                        ty += 4.5;
                    });
                    ty += 2;
                });
            }
        }
        fussnote();

        // ---------------------------------------------------------------
        // SEITE 2: Pflanzenliste als echte Tabelle
        // ---------------------------------------------------------------
        const bilder = await ladeProduktbilder(liste);
        pdf.addPage();
        y = rand;
        setz(15, 'bold', PDF_GRUEN);
        pdf.text('Deine Pflanzenliste', rand, y);
        y += 9;

        const spalten = [
            { x: rand,                    b: 13 },                    // Bild
            { x: rand + 13,               b: breite - 13 - 20 - 30 - 28 },
            { x: seiteBreite - rand - 78, b: 20, rechts: true },
            { x: seiteBreite - rand - 58, b: 30, rechts: true },
            { x: seiteBreite - rand - 28, b: 28, rechts: true }
        ];

        const kopfzeile = () => {
            pdf.setFillColor.apply(pdf, PDF_GRUEN);
            pdf.rect(rand, y, breite, 8, 'F');
            setz(9, 'bold', [255, 255, 255]);
            pdf.text('Pflanze', spalten[1].x + 2, y + 5.5);
            pdf.text('Anzahl', spalten[2].x + spalten[2].b - 2, y + 5.5, { align: 'right' });
            pdf.text('Einzelpreis', spalten[3].x + spalten[3].b - 2, y + 5.5, { align: 'right' });
            pdf.text('Gesamt', spalten[4].x + spalten[4].b - 2, y + 5.5, { align: 'right' });
            y += 8;
        };
        kopfzeile();

        const zeilen = liste.filter(z => z && z.Pflanze !== 'SUMME');
        const summe = liste.find(z => z && z.Pflanze === 'SUMME');
        const zeilenHoehe = 13;

        zeilen.forEach((zeile, i) => {
            if (y + zeilenHoehe > seiteHoehe - 22) {
                fussnote();
                pdf.addPage();
                y = rand;
                kopfzeile();
            }
            if (i % 2 === 1) {
                pdf.setFillColor.apply(pdf, PDF_HELL);
                pdf.rect(rand, y, breite, zeilenHoehe, 'F');
            }
            const handle = handleAusLink(zeile.product_url);
            if (handle && bilder[handle]) {
                pdf.addImage(bilder[handle], 'JPEG', rand + 1.5, y + 1.5, 10, 10);
            }
            setz(9.5, 'normal');
            const name = pdf.splitTextToSize(
                String(zeile.display_name || zeile.Pflanze || ''), spalten[1].b - 4);
            pdf.text(name.slice(0, 2), spalten[1].x + 2, y + (name.length > 1 ? 5.5 : 8));
            if (zeile.source === 'manual') {
                setz(7, 'normal', PDF_GRAU);
                pdf.text('von dir gewählt', spalten[1].x + 2, y + 11.5);
            }
            setz(9.5, 'normal');
            pdf.text(String(zeile.Anzahl), spalten[2].x + spalten[2].b - 2, y + 8, { align: 'right' });
            pdf.text(String(zeile.Einzelpreis || ''), spalten[3].x + spalten[3].b - 2, y + 8, { align: 'right' });
            setz(9.5, 'bold', PDF_GRUEN);
            pdf.text(String(zeile.Gesamt || ''), spalten[4].x + spalten[4].b - 2, y + 8, { align: 'right' });

            pdf.setDrawColor.apply(pdf, PDF_LINIE);
            pdf.setLineWidth(0.2);
            pdf.line(rand, y + zeilenHoehe, seiteBreite - rand, y + zeilenHoehe);
            y += zeilenHoehe;
        });

        if (summe) {
            if (y + 12 > seiteHoehe - 22) { fussnote(); pdf.addPage(); y = rand; }
            pdf.setFillColor.apply(pdf, PDF_GRUEN);
            pdf.rect(rand, y, breite, 11, 'F');
            setz(11, 'bold', [255, 255, 255]);
            pdf.text('Gesamtsumme', spalten[1].x + 2, y + 7.5);
            pdf.text(String(summe.Gesamt || ''), seiteBreite - rand - 2, y + 7.5, { align: 'right' });
            y += 26;
        }

        // ---------------------------------------------------------------
        // Beschreibung als Fliesstext
        // ---------------------------------------------------------------
        const beschreibung = document.querySelector('#plantAccordions .design-description');
        if (beschreibung) {
            pdfBeschreibung(pdf, beschreibung, {
                rand, breite, seiteHoehe, y, setz,
                neueSeite: () => { fussnote(); pdf.addPage(); return rand; }
            });
        }
        fussnote();

        // ---------------------------------------------------------------
        // Fusszeilen auf allen Seiten
        // ---------------------------------------------------------------
        const gesamt = pdf.getNumberOfPages();
        for (let s = 1; s <= gesamt; s++) {
            pdf.setPage(s);
            pdf.setDrawColor.apply(pdf, PDF_LINIE);
            pdf.setLineWidth(0.2);
            pdf.line(rand, seiteHoehe - 14, seiteBreite - rand, seiteHoehe - 14);
            setz(8, 'normal', PDF_GRAU);
            pdf.text('Erstellt mit dem Gartenplaner von Baumfink · baumfink.de',
                     rand, seiteHoehe - 9);
            pdf.text(`Seite ${s} von ${gesamt}`, seiteBreite - rand, seiteHoehe - 9,
                     { align: 'right' });
        }

        const datei = 'Gartenplan-' + titel
            .replace(/[^\wäöüÄÖÜß -]/g, '').replace(/\s+/g, '-').slice(0, 60) + '.pdf';
        pdf.save(datei);
        toast('PDF heruntergeladen!', CONFIG.COLORS.success);

    } catch (fehler) {
        console.error('Fehler bei der PDF-Erstellung:', fehler);
        toast('Fehler beim PDF-Download: ' + fehler.message, CONFIG.COLORS.error);
    } finally {
        if (knopf) { knopf.disabled = false; knopf.innerHTML = altText; }
    }
}

// Die Eckdaten neben dem Vorher-Bild. Aus der Stueckliste gerechnet, nicht aus
// dem Bildschirm gelesen.
function pdfKennzahlen(liste) {
    const zeilen = liste.filter(z => z && z.Pflanze !== 'SUMME');
    const stueck = zeilen.reduce((s, z) => s + (parseInt(z.Anzahl, 10) || 0), 0);
    const summe = liste.find(z => z && z.Pflanze === 'SUMME');
    const zahlen = [
        ['PFLANZEN', String(stueck)],
        ['SORTEN', String(zeilen.length)]
    ];
    if (summe && summe.Gesamt) zahlen.push(['GESAMTPREIS', String(summe.Gesamt)]);
    return zahlen;
}

// Beschreibungstext setzen. Ueberschriften in Normalschrift statt in gesperrten
// Versalien - im Ausdruck liest sich das sonst wie Geschrei.
function pdfBeschreibung(pdf, wurzel, o) {
    let y = o.y;
    if (y > o.seiteHoehe - 60) y = o.neueSeite();

    o.setz(15, 'bold', PDF_GRUEN);
    pdf.text('Zu deinem Entwurf', o.rand, y);
    y += 9;

    [...wurzel.children].forEach(el => {
        const text = (el.textContent || '').trim();
        if (!text) return;
        const istUeberschrift = /^H[1-6]$/.test(el.tagName);

        if (istUeberschrift) {
            if (y > o.seiteHoehe - 40) y = o.neueSeite();
            y += 3;
            o.setz(11, 'bold', [40, 38, 34]);
            // Der Bildschirm setzt die Ueberschriften in Versalien (CSS).
            // textContent liefert sie normal - genau richtig fuers Papier.
            pdf.text(text, o.rand, y);
            y += 6;
            return;
        }

        o.setz(9.5, 'normal', [60, 57, 52]);
        const zeilen = pdf.splitTextToSize(text, o.breite);
        zeilen.forEach(zeile => {
            if (y > o.seiteHoehe - 22) y = o.neueSeite();
            pdf.text(zeile, o.rand, y);
            y += 5;
        });
        y += 3;
    });
}

// ============================================================================
// STORAGE & RESTORE
// ============================================================================

function restoreResults() {
    // Nicht wiederherstellen wenn ein Request aktiv ist
    if (activeRequest) {
        console.log('Gartenplaner: Überspringe Wiederherstellung (Request aktiv)');
        return;
    }

    const saved = localStorage.getItem(STORAGE_KEYS.session);
    if (saved) {
        try {
            const storageData = JSON.parse(saved);

            if (storageData.expiresAt && Date.now() > storageData.expiresAt) {
                vergissGespeichertenStand();
                return;
            }
            if (!speicherstandGueltig(storageData)) {
                console.warn('Gartenplaner: gespeicherter Stand unplausibel, verworfen');
                vergissGespeichertenStand();
                return;
            }

            const images = storageData.images || [];
            const alternatives = storageData.alternatives || [];
            const titles = storageData.titles || [];
            const descriptions = storageData.descriptions || [];
            // Aeltere Staende haben das Feld nicht - dann bleibt der
            // Hinweisblock einfach leer, statt die Wiederherstellung zu kippen.
            const hinweise = storageData.hinweise || [];
            // Aeltere Staende kennen die Felder nicht - dann faellt der
            // Vergleich einfach weg, statt die Wiederherstellung zu kippen.
            _originalFoto = _originalFoto || ladeFoto();
            window.gpVergleiche = storageData.vergleiche || [];
            window.neuentwuerfe = storageData.neuentwuerfe || { verbraucht: 0, grenze: 3 };
            if (storageData.sessionId) window.gpSessionId = storageData.sessionId;

            // Wenn keine Bilder UND keine Pflanzlisten vorhanden, nichts wiederherstellen
            if (images.length === 0 && alternatives.length === 0) {
                console.warn('Keine gespeicherten Daten gefunden');
                localStorage.removeItem(STORAGE_KEYS.session);
                return;
            }

            // Wenn Bilder fehlen aber Pflanzlisten vorhanden, trotzdem wiederherstellen
            // (zeigt dann den "Bildgenerierung fehlgeschlagen" Hinweis)
            if (images.length === 0 && alternatives.length > 0) {
                console.log('Gartenplaner: Stelle Ergebnisse ohne Bilder wieder her');
            }

            const data = {
                status: storageData.bildHinweis ? 'partial' : 'success',
                hinweis: storageData.bildHinweis || null,
                image_data_uris: images,
                plant_alternatives: alternatives,
                alternative_titles: titles,
                alternative_descriptions: descriptions,
                pflanzenhinweise: hinweise[0] || [],
                vergleiche: window.gpVergleiche,
                // MUSS mit: displayResults() setzt window.neuentwuerfe aus
                // DIESEM Objekt und ueberschrieb sonst den gerade
                // wiederhergestellten Stand mit dem Standard. Der Zaehler
                // sprang nach jedem Reload auf 0 von 3 zurueck - und
                // saveToStorage() am Ende von displayResults() schrieb den
                // falschen Wert auch noch in den Speicher. Serverseitig gilt
                // die Grenze weiter, der Kunde bekam also beim vierten Versuch
                // grundlos ein 429 statt eines gesperrten Knopfes.
                neuentwuerfe: window.neuentwuerfe
            };

            if (DOM.results && !DOM.results.classList.contains('show')) {
                displayResults(data);
                console.log('Gartenplaner: Ergebnisse erfolgreich wiederhergestellt');
            }
            planeAblauf(storageData.expiresAt);
        } catch (e) {
            console.error('Failed to restore results:', e);
            localStorage.removeItem(STORAGE_KEYS.session);
        }
    }
}

// ============================================================================
// UI ACTIONS
// ============================================================================

function resetPlanner() {
    if (confirm('Möchtest du wirklich einen neuen Entwurf starten? Deine aktuellen Ergebnisse werden gelöscht.')) {
        vergissGespeichertenStand();
        clearAddedAlternatives();
        window.gpVergleiche = [];

        if (DOM.results) DOM.results.classList.remove('show');
        if (DOM.inputSection) DOM.inputSection.classList.remove('hidden');

        const form = document.getElementById('plannerForm');
        if (form) form.reset();

        if (DOM.fileInput) DOM.fileInput.value = '';
        if (DOM.fileName) DOM.fileName.textContent = '';
        if (DOM.deleteBtn) DOM.deleteBtn.style.display = 'none';
        if (DOM.imageGrid) DOM.imageGrid.innerHTML = '';
        if (DOM.plantAccordions) DOM.plantAccordions.innerHTML = '';

        alternativesCount = 0;

        if (DOM.createAdditionalBtn) DOM.createAdditionalBtn.style.display = 'none';

        window.scrollTo({ top: 0, behavior: 'smooth' });
        toast('Bereit für einen neuen Entwurf!', CONFIG.COLORS.success);
        window.location.reload();
    }
}

function openRefine() {
    const currentDesc = DOM.description?.value.trim() || '';
    if (currentDesc) {
        DOM.refineText.value = currentDesc;
    }

    if (DOM.refineDrawer.style.right === '0px') {
        DOM.refineDrawer.style.right = `-${CONFIG.DRAWER_WIDTH}`;
    } else {
        DOM.refineDrawer.style.right = '0';
    }
}

function closeRefine() {
    DOM.refineDrawer.style.right = `-${CONFIG.DRAWER_WIDTH}`;
}

function buildRefineDescription() {
    const base = DOM.description?.value.trim() || '';
    const extra = (DOM.refineText?.value || '').trim();
    return extra ? `${base}\n${extra}` : base;
}

function updateRefineTextFromChips() {
    const chips = [...document.querySelectorAll('#refineChips .active')].map(el => el.textContent);
    let currentText = (DOM.refineText.value || '').split('\n').filter(line => !line.startsWith('Anpassungen:')).join('\n').trim();

    if (chips.length > 0) {
        const chipsLine = 'Anpassungen: ' + chips.join(', ');
        currentText = currentText ? `${currentText}\n${chipsLine}` : chipsLine;
    }
    DOM.refineText.value = currentText.trim();
}

// ============================================================================
// BUTTON STATE MANAGEMENT
// ============================================================================

function setSubmitButtonLoading(isLoading) {
    if (!DOM.submitBtn) return;

    if (isLoading) {
        DOM.submitBtn.disabled = true;
        DOM.submitBtn.dataset.originalText = DOM.submitBtn.textContent;
        DOM.submitBtn.textContent = 'Wird generiert...';
        DOM.submitBtn.classList.add('loading');
    } else {
        DOM.submitBtn.disabled = false;
        DOM.submitBtn.textContent = DOM.submitBtn.dataset.originalText || 'Gartenplan erstellen';
        DOM.submitBtn.classList.remove('loading');
    }
}

function setRefineButtonLoading(isLoading) {
    if (!DOM.runRefineBtn) return;

    if (isLoading) {
        DOM.runRefineBtn.disabled = true;
        DOM.runRefineBtn.dataset.originalText = DOM.runRefineBtn.textContent;
        DOM.runRefineBtn.textContent = 'Wird generiert...';
        DOM.runRefineBtn.classList.add('loading');
    } else {
        DOM.runRefineBtn.disabled = false;
        DOM.runRefineBtn.textContent = DOM.runRefineBtn.dataset.originalText || 'Variante erstellen';
        DOM.runRefineBtn.classList.remove('loading');
    }
}

// ============================================================================
// INITIALIZATION
// ============================================================================

document.addEventListener('DOMContentLoaded', () => {
    cacheDOMElements();
    console.info('Gartenplaner ' + GP_VERSION);

    // E-19: ein Klick-Verteiler statt Inline-Handlern (onclick="..."). Inline-
    // Handler verhindern eine strikte Content-Security-Policy und binden die
    // Vorlagen an globale Funktionsnamen. Die Knoepfe tragen data-aktion und
    // data-alt-index (renderImageCard, renderNeuentwurfLeiste).
    document.addEventListener('click', (e) => {
        const knopf = e.target.closest('button[data-aktion]');
        if (!knopf || knopf.disabled) return;
        const altIdx = parseInt(knopf.dataset.altIndex, 10);
        if (!Number.isFinite(altIdx)) return;
        if (knopf.dataset.aktion === 'warenkorb') {
            e.preventDefault();
            window.addAlternativeToCart(altIdx);
        } else if (knopf.dataset.aktion === 'neuentwurf') {
            e.preventDefault();
            window.regenerateDraft(altIdx);
        }
    });

    // Altlast aufraeumen: bis 04.09.2026 lag der "im Warenkorb"-Vermerk im
    // localStorage und ueberlebte damit Sitzung und Entwurf. Bestandsnutzer
    // tragen den Eintrag noch im Browser; er wird hier einmalig entfernt.
    try {
        localStorage.removeItem(STORAGE_KEYS.addedCart);
    } catch (e) { /* egal */ }

    // File handling
    if (DOM.fileInput && DOM.fileName && DOM.deleteBtn && DOM.fileDrop) {
        DOM.fileInput.addEventListener('change', (e) => {
            if (e.target.files.length > 0) {
                DOM.fileName.textContent = e.target.files[0].name;
                DOM.deleteBtn.style.display = 'inline-block';
            } else {
                DOM.fileName.textContent = 'Keine Datei ausgewählt';
                DOM.deleteBtn.style.display = 'none';
            }
        });

        DOM.deleteBtn.addEventListener('click', (e) => {
            e.preventDefault();
            DOM.fileInput.value = '';
            _lastImageDataUri = null;
            DOM.fileName.textContent = 'Keine Datei ausgewählt';
            DOM.deleteBtn.style.display = 'none';
            sessionStorage.removeItem(STORAGE_KEYS.session);
            if (DOM.inputSection) DOM.inputSection.classList.remove('hidden');
            if (DOM.results) DOM.results.classList.remove('show');
        });

        ['dragenter', 'dragover'].forEach(evt => {
            DOM.fileDrop.addEventListener(evt, (e) => {
                e.preventDefault();
                e.stopPropagation();
                DOM.fileDrop.classList.add('dragover');
            });
        });

        ['dragleave', 'drop'].forEach(evt => {
            DOM.fileDrop.addEventListener(evt, (e) => {
                e.preventDefault();
                e.stopPropagation();
                DOM.fileDrop.classList.remove('dragover');
            });
        });

        DOM.fileDrop.addEventListener('drop', (e) => {
            const dt = e.dataTransfer;
            if (!dt || !dt.files || !dt.files.length) return;
            const file = dt.files[0];
            if (!/image\/(png|jpe?g|webp)/i.test(file.type)) {
                toast('Bitte PNG, JPG oder WEBP hochladen', CONFIG.COLORS.error);
                return;
            }
            const d = new DataTransfer();
            d.items.add(file);
            DOM.fileInput.files = d.files;
            DOM.fileInput.dispatchEvent(new Event('change'));
        });
    }

    // Paste handling
    document.addEventListener('paste', (e) => {
        if (!e.clipboardData) return;
        const items = e.clipboardData.items;
        for (let i = 0; i < items.length; i++) {
            const it = items[i];
            if (it.kind === 'file') {
                const file = it.getAsFile();
                if (file && /image\/(png|jpe?g|webp)/i.test(file.type)) {
                    const d = new DataTransfer();
                    d.items.add(file);
                    DOM.fileInput.files = d.files;
                    DOM.fileInput.dispatchEvent(new Event('change'));
                    toast('Bild eingefügt', CONFIG.COLORS.success);
                    break;
                }
            }
        }
    });

    // Starter chips
    if (DOM.starterChips) {
        CONFIG.STARTER_PROMPTS.forEach(prompt => {
            const chip = document.createElement('span');
            chip.textContent = prompt;
            chip.addEventListener('click', () => {
                DOM.description.value = prompt;
                toast('Prompt übernommen', CONFIG.COLORS.success);
            });
            DOM.starterChips.appendChild(chip);
        });
    }

    // Planting mode sync
    const plantingModeRadios = document.querySelectorAll('input[name="modeSelector"]');
    if (plantingModeRadios.length > 0 && DOM.plantingMode) {
        plantingModeRadios.forEach(radio => {
            radio.addEventListener('change', () => {
                if (radio.checked) {
                    DOM.plantingMode.value = radio.value;
                }
            });
        });

        const initialChecked = document.querySelector('input[name="modeSelector"]:checked');
        if (initialChecked) {
            DOM.plantingMode.value = initialChecked.value;
        }
    }

    // Submit button - MIT REQUEST-TRACKING
    DOM.submitBtn.addEventListener('click', async function() {
        // Verhindere Doppelklicks
        if (activeRequest) {
            console.log('Request läuft bereits, ignoriere Klick');
            return;
        }

        const description = DOM.description.value.trim();
        const plantingModeRadio = document.querySelector('input[name="modeSelector"]:checked');
        const plantingMode = plantingModeRadio ? plantingModeRadio.value : 'border_lawn';
        const imageFile = DOM.fileInput.files[0];
        const apiUrl = getApiUrl();

        if (!description) {
            alert('Bitte beschreibe deinen Garten.');
            return;
        }
        if (!imageFile) {
            alert('Bitte lade ein Gartenfoto hoch.');
            return;
        }

        // WICHTIG: Alte Session löschen bei NEUER Anfrage
        // Verhindert dass alte gecachte Bilder bei fehlgeschlagener Bildgenerierung angezeigt werden
        localStorage.removeItem(STORAGE_KEYS.session);
        clearAddedAlternatives();
        console.log('Alte Session gelöscht für neue Anfrage');

        // Verkleinerte Fassung des Fotos fuer den Vorher-Nachher-Vergleich.
        // Muss HIER entstehen: nach dem Lauf traegt _lastImageDataUri das
        // erzeugte Bild, das Original waere dann nicht mehr im Browser.
        // Ein Fehlschlag ist folgenlos - dann gibt es eben keinen Vergleich.
        _originalFoto = null;
        try {
            _originalFoto = await verkleinereFoto(imageFile);
        } catch (fehler) {
            console.warn('Vergleich: Foto konnte nicht verkleinert werden.', fehler);
        }

        const reader = new FileReader();

        reader.onload = async function(event) {
            const base64DataUri = event.target.result;
            _lastImageDataUri = base64DataUri;

            // Request-Tracking aktivieren
            activeRequest = true;
            setSubmitButtonLoading(true);

            DOM.loadingDiv.classList.add('show');
            DOM.results.classList.remove('show');
            DOM.errorBox.classList.remove('show');
            startProgress();

            try {
                // Wake Lock aktivieren (verhindert Bildschirm-Standby)
                await acquireWakeLock();

                // 1. Job starten (antwortet sofort mit job_id)
                const startResponse = await fetchWithRetry(apiUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    // Entscheidung 10: session_id auf ALLEN Aufrufen. Bis jetzt
                    // wurde sie nur aus der Antwort gelesen und nie
                    // zurueckgeschickt - jeder POST erzeugte deshalb eine neue
                    // Sitzung, und der serverseitige Bildcache lief leer.
                    // Beim ERSTEN Entwurf bleibt sie leer: der Server vergibt sie.
                    body: JSON.stringify({ description, image_data_uri: base64DataUri, planting_mode: plantingMode, marketing_consent: document.getElementById('marketingConsent')?.checked || false })
                });

                const startData = await startResponse.json();

                // Rate Limit oder Validierungsfehler
                if (startData.status === 'error') {
                    throw new Error(startData.error || 'Unbekannter Fehler');
                }

                // Job gestartet - jetzt auf Ergebnis warten
                if (startData.status !== 'accepted' || !startData.job_id) {
                    throw new Error('Unerwartete Server-Antwort');
                }

                console.log('Job gestartet:', startData.job_id);

                // 2. Auf Job-Ergebnis warten (pollt alle 3s)
                logPoll('important', '⏳ Warte auf pollJobResult...');
                const result = await pollJobResult(startData.job_id);
                // H.4.2: Session-ID merken, damit ein Warenkorb-Klick dem
                // Entwurf zugeordnet werden kann. Sie steht ohnehin in der
                // Job-Antwort (app.py, response_data['session_id']).
                window.gpSessionId = result && result.session_id;
                logPoll('important', '✅ pollJobResult returned!', {
                    hasResult: !!result,
                    resultType: typeof result,
                    resultKeys: result ? Object.keys(result).slice(0, 5) : []
                });

                // 3. Ergebnis anzeigen
                logPoll('important', '🎨 Calling displayResults...');
                try {
                    displayResults(result);
                    logPoll('important', '✅ displayResults completed!');
                } catch (displayErr) {
                    logPoll('error', '💥 displayResults FAILED:', displayErr.message, displayErr.stack);
                    throw displayErr;
                }

                logPoll('important', '📊 Calling doneProgress...');
                doneProgress();
                logPoll('important', '🎉 Calling toast...');
                toast('Fertig!', CONFIG.COLORS.success);
                logPoll('important', '🏁 SUCCESS - All done!');
            } catch (error) {
                logPoll('error', '❌ CATCH BLOCK:', error.message, error.stack);
                console.error('Error:', error);

                // Spezielle Behandlung für Rate Limiting
                if (handleRateLimitError(error)) {
                    // Bei Rate Limit: Keine Fehlerbox, nur Toast
                    if (error.reason !== 'cooldown') {
                        setSubmitButtonLoading(false);
                    }
                } else {
                    // Normale Fehlerbehandlung
                    DOM.errorMessage.textContent = error.message;
                    DOM.errorBox.classList.add('show');
                    toast('Fehler bei der Generierung.', CONFIG.COLORS.error);
                    setSubmitButtonLoading(false);
                }
                doneProgress();
            } finally {
                logPoll('important', '🧹 FINALLY block starting...');
                try {
                    DOM.loadingDiv.classList.remove('show');
                    logPoll('info', '  - loadingDiv hidden');
                } catch (e) { logPoll('error', '  - loadingDiv error:', e.message); }

                activeRequest = null;
                logPoll('info', '  - activeRequest = null');

                try {
                    resetProgress();
                    logPoll('info', '  - resetProgress done');
                } catch (e) { logPoll('error', '  - resetProgress error:', e.message); }

                try {
                    await releaseWakeLock();
                    logPoll('info', '  - wakeLock released');
                } catch (e) { logPoll('error', '  - wakeLock error:', e.message); }

                localStorage.removeItem('pending_job_id');
                logPoll('important', '🧹 FINALLY block completed!');
            }
        };

        reader.onerror = function() {
            alert('Fehler beim Lesen der Bilddatei.');
            DOM.loadingDiv.classList.remove('show');
            setSubmitButtonLoading(false);
            activeRequest = null;
        };

        reader.readAsDataURL(imageFile);
    });

    // PDF download
    if (DOM.pdfDownloadBtn) {
        DOM.pdfDownloadBtn.addEventListener('click', generatePDF);
    }

    // Refresh button
    if (DOM.refreshBtn) {
        DOM.refreshBtn.addEventListener('click', resetPlanner);
    }

    // Retry button
    if (DOM.retryBtn) {
        DOM.retryBtn.addEventListener('click', () => {
            DOM.errorBox.classList.remove('show');
            DOM.submitBtn.click();
        });
    }

    // Refine drawer
    if (DOM.createAdditionalBtn) {
        DOM.createAdditionalBtn.addEventListener('click', openRefine);
    }
    if (DOM.closeRefineBtn) {
        DOM.closeRefineBtn.addEventListener('click', closeRefine);
    }

    // Refine chips
    if (DOM.refineChips) {
        CONFIG.CHIP_PRESETS.forEach(txt => {
            const c = document.createElement('span');
            c.className = 'chip';
            c.textContent = txt;
            c.style.cssText = 'display:inline-block;padding:8px 12px;border:1px solid var(--baumfink-border-light);border-radius:999px;cursor:pointer;font-size:14px;background:#fff;user-select:none;';
            c.addEventListener('click', () => {
                c.classList.toggle('active');
                c.style.borderColor = c.classList.contains('active') ? 'var(--baumfink-green-button)' : 'var(--baumfink-border-light)';
                c.style.background = c.classList.contains('active') ? '#F1FBF4' : '#fff';
                updateRefineTextFromChips();
            });
            DOM.refineChips.appendChild(c);
        });
    }

    // Run refine - MIT REQUEST-TRACKING
    if (DOM.runRefineBtn) {
        DOM.runRefineBtn.addEventListener('click', async () => {
            // Verhindere Doppelklicks
            if (activeRequest) {
                console.log('Request läuft bereits, ignoriere Klick');
                return;
            }

            const currentCount = document.querySelectorAll('#imageGrid .image-card').length;
            if (currentCount >= CONFIG.MAX_ALTERNATIVES) {
                toast(`Maximal ${CONFIG.MAX_ALTERNATIVES} Alternativen möglich`, CONFIG.COLORS.error);
                closeRefine();
                return;
            }

            const apiUrl = getApiUrl();
            const plantingModeRadio = document.querySelector('input[name="modeSelector"]:checked');
            const plantingMode = plantingModeRadio ? plantingModeRadio.value : 'border_lawn';

            let imageDataUri = _lastImageDataUri;
            if (!imageDataUri) {
                const file = DOM.fileInput.files[0];
                if (!file) {
                    toast('Kein Bild vorhanden. Bitte zuerst hochladen.', CONFIG.COLORS.error);
                    return;
                }
                imageDataUri = await new Promise((resolve, reject) => {
                    const r = new FileReader();
                    r.onload = e => resolve(e.target.result);
                    r.onerror = () => reject(new Error('Bild konnte nicht gelesen werden.'));
                    r.readAsDataURL(file);
                });
            }

            const description = buildRefineDescription();

            // Request-Tracking aktivieren
            activeRequest = true;
            setRefineButtonLoading(true);

            DOM.refineLoadingDiv.classList.add('show');
            DOM.loadingDiv.classList.add('show');
            startProgress();

            try {
                // Wake Lock aktivieren
                await acquireWakeLock();

                const bodyPayload = {
                    description,
                    image_data_uri: imageDataUri,
                    planting_mode: plantingMode,
                    marketing_consent: document.getElementById('marketingConsent')?.checked || false
                };
                // Entscheidung 10: hier ist die Sitzung bekannt. Damit nutzt
                // der Server sein gespeichertes Originalfoto, statt das aus dem
                // Browser erneut zu verarbeiten.
                if (window.gpSessionId) bodyPayload.session_id = window.gpSessionId;

                // 1. Job starten
                const startResponse = await fetchWithRetry(apiUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(bodyPayload)
                });

                const startData = await startResponse.json();

                if (startData.status === 'error') {
                    throw new Error(startData.error || 'Unbekannter Fehler');
                }

                if (startData.status !== 'accepted' || !startData.job_id) {
                    throw new Error('Unerwartete Server-Antwort');
                }

                console.log('Refine-Job gestartet:', startData.job_id);

                // 2. Auf Job-Ergebnis warten
                const result = await pollJobResult(startData.job_id);

                // 3. Ergebnis anzeigen
                appendVariant(result);
                doneProgress();
                toast('Neue Variante hinzugefügt!', CONFIG.COLORS.success);
                closeRefine();
                document.querySelectorAll('#refineChips .active').forEach(c => c.classList.remove('active'));
                DOM.refineText.value = '';
            } catch (e) {
                doneProgress();

                // Spezielle Behandlung für Rate Limiting
                if (handleRateLimitError(e)) {
                    closeRefine();
                } else {
                    toast('Fehler: ' + e.message, CONFIG.COLORS.error);
                }
            } finally {
                DOM.loadingDiv.classList.remove('show');
                DOM.refineLoadingDiv.classList.remove('show');
                resetProgress();
                setRefineButtonLoading(false);
                activeRequest = null;
                await releaseWakeLock();
                localStorage.removeItem('pending_job_id');
            }
        });
    }

    // =========================================================================
    // MOBILE VISIBILITY HANDLER - Wake Lock Wiederherstellung
    // =========================================================================

    document.addEventListener('visibilitychange', async () => {
        if (document.visibilityState === 'visible') {
            // Wake Lock DEAKTIVIERT - verursachte Probleme
            // Hinweis wenn Job noch läuft
            const pendingJobId = localStorage.getItem('pending_job_id');
            if (pendingJobId && DOM.loadingDiv?.classList.contains('show')) {
                toast('Generierung läuft noch...', '#3b82f6');
            }
        }
    });

    // Restore results on load
    restoreResults();

    // Restore on back/forward navigation
    window.addEventListener('pageshow', function(event) {
        if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
            console.log('Gartenplaner: Seite aus Cache geladen');
            restoreResults();
        }
    });

    // Fallback restore - NUR wenn kein aktiver Request läuft
    setTimeout(function() {
        // Nicht wiederherstellen wenn ein Request aktiv ist
        if (activeRequest) {
            console.log('Gartenplaner: Überspringe Fallback-Wiederherstellung (Request aktiv)');
            return;
        }
        const saved = localStorage.getItem(STORAGE_KEYS.session);
        if (saved && DOM.results && !DOM.results.classList.contains('show')) {
            console.log('Gartenplaner: Fallback-Wiederherstellung');
            restoreResults();
        }
    }, 100);

});